<template>
  <div v-if="banner && visible && countdown" class="banner-holder" :class="bannerClass">
    <div v-if="[1, 2, 3, 99].includes(banner.type)" class="close-banner" @click="removeBanner">
      <CloseIcon />
    </div>
    <a
      class="banner"
      :class="[
        banner.classBanner,
        banner.type !== 2 && banner.type !== 1 && banner.type !== 99 && sideBanner && side ? 'side' : 'inline',
        [1, 2, 3, 99].includes(banner.type) ? 'container' : '',
        $store.state.sideBarExpanded ? 'small' : ''
      ]"
      @click.prevent="click(banner)"
    >
      <div v-if="banner.type === 0" class="icon-slot">
        <slot name="icon" />
      </div>
      <div v-if="banner.type === 3 && banner.image && !$store.getters['auth/user'].simpleLms" class="icon-wrap">
        <img :src="`${$config.imagesUrl}/card-collections/${banner.image}`">
      </div>
      <div v-if="banner.type === 1 || banner.type === 2 || banner.type === 99" class="header-wrap" :class="[$config.platform, $config.project, { extend: promotion.extend }]">
        <template v-if="$store.state.campaign === 'jumpstart-2025'">
          <span class="block limited-offer mobile-only">Limited-Time Offer</span>
          <span class="highlight white special">JUMPSTART 2025</span>
          <span class="block">WITH <span class="highlight blue special">{{ $config.platform === 'ds' ? 'DATA & AI' : 'FINANCE' }} COURSES</span></span>
        </template>
        <template v-else-if="$store.state.campaign === 'cyber-monday-lifetime-2024'">
          <div>
            <span class="highlight white">LIFETIME PASS</span>
            <span class="block">
              All {{ $config.platform === 'ds' ? 'Data and AI' : 'Finance' }} Courses
            </span>
          </div>
          <component :is="discountLogo" />
        </template>
        <template v-else-if="$store.state.campaign === 'cyber-monday-2024'">
          <span class="highlight yellow">{{ promotion.discount }}<span class="smaller">%<span class="block off">OFF</span></span></span>
          <div>
            <span class="block highlight blue">CYBER MONDAY</span>
            <span class="block">
              Limited-Time Offer
            </span>
          </div>
        </template>
        <template v-else-if="$store.state.campaign === 'black-friday-2024'">
          <span class="highlight yellow">{{ promotion.discount }}<span class="smaller">%<span class="block off">OFF</span></span></span>
          <div>
            <span class="block highlight red">BLACK FRIDAY</span>
            <span class="block">
              Limited-Time Offer
            </span>
          </div>
        </template>
        <template v-else-if="$store.state.campaign === 'free-weeks-2024'">
          <div>
            <span class="highlight campaign-1 blue">ALL {{ $config.platform === 'ds' ? 'DATA & AI' : 'FINANCE' }}</span>
            <span class="block">COURSES</span>
          </div>
          <component :is="$config.platform === 'ds' ? 'Free' : 'FreeFa'" />
        </template>
        <template v-else-if="['learn-data-and-ai', 'learn-data-and-ai-new', 'learn-finance'].includes($store.state.campaign)">
          <template v-if="promotion.extend">
            <span class="extend-label">DEADLINE EXTENDED</span><br>
          </template>
          <span class="block">Learn</span>
          <span class="highlight yellow special">
            {{ $config.platform === 'ds' ? 'DATA & AI' : 'FINANCE' }}
          </span>
          <span class="inline">at <span class="highlight blue special">{{ promotion.discount }}% <span class="smaller">OFF</span></span></span>
        </template>
        <template v-else-if="$store.state.campaign === 'future-proof-2024'">
          <div class="code-block">
            <img :src="require('@itbpbg/lms-components/src/assets/images/campaign-future-proof/learn-future-proof.webp')" alt="learn future-proof">
          </div>
          <div class="bottom">
            <span class="highlight blue special">
              DATA AND AI SKILLS
            </span>
            <span class="block text-2">
              <span class="small">at</span> <span class="highlight yellow">{{ promotion.discount }}% OFF</span>
            </span>
          </div>
        </template>
        <template v-else-if="$store.state.campaign === 'fast-track-2024'">
          <span class="bg-highlight" title="Fast-Track">Fast-Track</span> Your
          <span class="block">
            <span class="highlight blue" title="Finance Career">Finance Career</span>
            at <span class="highlight yellow">{{ promotion.discount }}% OFF</span>
          </span>
        </template>
        <template v-else-if="$store.state.campaign === 'most-wanted-2024'">
          <div class="left">
            <img v-if="promotion.extend" class="extend-stamp" :src="require(`./assets/images/campaigns/${$config.platform}-mw-extend.webp`)">
            <template v-if="$config.platform === 'ds'">
              <img class="desktop-only" :src="require(`./assets/images/campaigns/${$config.platform}-mw-title.webp`)">
              <img v-if="$config.platform === 'ds'" class="laptop-only" :src="require(`./assets/images/campaigns/${$config.platform}-mw-title-left.webp`)">
              <span class="block"><span class="highlight campaign-1">DATA</span> AND <span class="highlight campaign-2">AI</span> COURSES</span>
            </template>
            <template v-else>
              <span class="block">MOST <img class="inline-block" :src="require(`./assets/images/campaigns/${$config.platform}-mw-title.webp`)"></span>
              <span class="highlight campaign-3">FINANCE COURSES</span>
            </template>
          </div>
          <div class="right highlight campaign-fa-2">
            65% OFF
          </div>
        </template>
        <template v-else-if="$store.state.campaign === 'transform-your-future-2024'">
          <div class="line-1">
            <span class="highlight campaign-1">Transform</span> <span class="bigger">Your</span><br class="mobile-only"> <b>FUTURE</b> in <span class="highlight campaign-1">2024</span>
          </div>
          <div class="line-2">
            <span class="bigger">LEARN</span> <b>{{ $config.platform === 'ds' ? 'DATA AND AI SKILLS' : 'FINANCE' }}</b><br class="mobile-only"> AT <span class="highlight campaign-2">72% OFF</span>
          </div>
        </template>
        <template v-else-if="$store.state.campaign === 'cyber-monday-2023' && promotion.extend">
          <div v-show="$store.state.layout === 'desktop'" class="ext-label" style="--ratio: calc(208 / 91);">
            <img :src="require(`./assets/images/campaign-cyber-monday-2023/cm-ext-label.webp`)">
          </div>
          <div v-show="$store.state.layout === 'mobile'" class="ext-label" style="--ratio: calc(215 / 136);">
            <img :src="require(`./assets/images/campaign-cyber-monday-2023/cm-ext-label-mobile.webp`)">
          </div>
          <div class="main">
            <div class="img">
              <img v-show="$store.state.layout === 'desktop'" class="title-inline" :src="require(`./assets/images/campaign-cyber-monday-2023/${$config.platform}-cm-title-hero2.webp`)">
              <img v-show="$store.state.layout === 'mobile'" class="title-inline" :src="require(`./assets/images/campaign-cyber-monday-2023/${$config.platform}-cm-title-hero-mobile.webp`)">
            </div>
            <strong>CYBER MONDAY</strong>
          </div>
        </template>
        <template v-else-if="$store.state.campaign === 'cyber-monday-2023'">
          <div class="img">
            <img v-show="$store.state.layout === 'desktop'" class="title-inline" :src="require(`./assets/images/campaign-cyber-monday-2023/${$config.platform}-cm-title-hero2.webp`)">
            <img v-show="$store.state.layout === 'mobile'" class="title-inline" :src="require(`./assets/images/campaign-cyber-monday-2023/${$config.platform}-cm-title-hero-mobile.webp`)">
          </div>
          <div class="main">
            <strong>CYBER MONDAY</strong>
            <span>Limited-Time Offer</span>
          </div>
        </template>
        <template v-else-if="$store.state.campaign === 'black-friday-2023'">
          <div class="img">
            <img v-show="$store.state.layout === 'desktop'" class="title-inline" :src="require(`./assets/images/campaign-black-friday-2023/${$config.platform}-bf-title-hero.webp`)">
            <img v-show="$store.state.layout === 'mobile'" class="title-inline" :src="require(`./assets/images/campaign-black-friday-2023/${$config.platform}-bf-title-hero-mobile.webp`)">
          </div>
          <div class="main">
            <strong>BLACK FRIDAY</strong>
            <span>Limited-Time Offer</span>
          </div>
        </template>
        <template v-else-if="$store.state.campaign === 'free-access-2024'">
          <div class="line-1">
            <span class="highlight yellow">All You Can Learn</span> Weekend
          </div>
          <div class="line-2">
            Enjoy 80+ Courses
            <span class="highlight blue">
              100% FREE
            </span>
          </div>
        </template>
        <template v-else-if="$store.state.campaign === 'get-future-ready'">
          <span class="main">
            <span class="block">Get Future-Ready</span> <span class="small mobile-block">with</span>
          </span>
          <span class="highlight-special" title="Data and AI Skills">Data and AI Skills</span> <span class="mobile-block"><span class="small">at</span> <span class="bold">{{ promotion.discount }}% OFF</span></span>
        </template>
        <template v-else-if="$store.state.campaign === 'campaign-chat-gpt' && banner.type === 99">
          <div class="left">
            <div class="svg">
              <TechnologyAI />
            </div>
            <div class="title">
              Intro to <strong>ChatGPT</strong> and <strong>Generative AI</strong> course
            </div>
          </div>
          <div class="right">
            IS NOW
            <b class="highlight">FREE</b>
          </div>
        </template>
        <div
          v-else-if="$config.campaign === 'black-friday' || $config.campaign === 'finance-courses-offer'"
          :class="[{ 'bf-heading': $config.campaign === 'black-friday', 'fc-heading': $config.campaign === 'finance-courses-offer' }]"
        >
          <BlackFridayFonts
            v-if="$config.campaign === 'black-friday'"
            class="font"
            :words="['72%', 'OFF!']"
          />
          <GlitchFont
            v-else-if="$config.campaign === 'finance-courses-offer'"
            class="cm-font-wrapper"
            text="72% OFF!"
            :text-size="$store.state.layout === 'mobile' ? '75' : '58'"
          />
          <div>
            <p
              :class="{
                'black-friday': $config.campaign === 'black-friday',
                'finance-courses-offer': $config.campaign === 'finance-courses-offer'
              }"
            >
              {{ $config.campaign === 'finance-courses-offer' ? 'ALL FINANCE COURSES' : 'BLACK FRIDAY' }}
            </p>
            <p class="limited-time-offer">LIMITED-TIME OFFER</p>
          </div>
        </div>
        <div v-else-if="$store.state.campaign === 'top-finance-training'" class="title">
          <h1 class="main" v-html="promotion.final ? promotion.promoBannerFinalTitle.line1 : promotion.promoBannerTitle.line1" />
          <p class="subtitle" v-html="promotion.final ? promotion.promoBannerFinalTitle.line2 : promotion.promoBannerTitle.line2" />
        </div>
        <div v-else-if="$store.state.campaign === 'got-what-it-takes'" class="title">
          <div class="header-wrap">
            <div class="banner-header h5">
              <div class="heading">
                <p class="campaign-title">
                  <span class="highlighted-left">GOT WHAT</span>
                  <span class="highlighted-right">IT TAKES?</span>
                </p>
                <span class="promo-subtitle">Find out if a data science career is a good fit and start learning at
                  <span class="bolded">65% off.</span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="$store.state.campaign === 'one-of-two-hundred-2024'" class="title">
          <div class="line-1">Grab <span class="highlighted">1 of 200</span> <span class="fa-highlighted">SPECIAL-PRICE</span> ANNUAL PLANS</div>
          <div class="line-2">Only<span class="subscriptions">{{ subscriptionsLeft }}</span>left at this price</div>
        </div>
        <div v-else>
          <p v-if="banner.type === 1" class="banner-header h5">{{ banner.offerType }}</p>
          <p v-else class="banner-header h5" v-html="banner.header" />
          <p class="banner-info" v-html="banner.info" />
        </div>
      </div>
      <div v-if="banner.type === 0 || banner.type === 3" class="header-wrap">
        <p v-if="banner.type === 3" class="banner-header-top">
          <template v-if="$store.getters['auth/user'].simpleLms">
            <LogoPremiumAnnual /> Annual
          </template>
          <template v-else>
            You’ve unlocked a special discount!
          </template>
        </p>
        <p class="banner-header h5" v-html="banner.header" />
        <p v-if="banner.info" class="banner-info">{{ banner.info }}</p>
      </div>
      <CounterWithDiscount
        v-if="$store.state.campaign === 'top-finance-training'"
        :key="new Date(promotion.endDate).getTime()"
        discount-on-left
        hide-days
        discount-text="Current Discount"
        :discount="promotion.discount"
        :end-date="new Date(promotion.endDate)"
      />
      <CounterWithDiscount
        v-else-if="$store.state.campaign === 'jumpstart-2025' && banner.type === 2"
        :counter-class="counterClass"
        :discount-on-left="promotion.counterDiscountOnLeft"
        :discount-on-right="promotion.counterDiscountOnRight"
        :hide-days="promotion.counterHideDays"
        :discount="promotion.discount"
        :discount-text="countdownCurrentDiscount"
        :end-date="new Date(promotion.endDate)"
      />
      <CounterWithDiscount
        v-else-if="$store.state.campaign !== 'one-of-two-hundred-2024' && [1, 2, 3, 99].includes(banner.type)"
        :counter-class="counterClass"
        :utc-end-date="banner.countDownDate" :hide-days="$store.state.campaign === 'free-days'"
      />
      <button v-if="showBannerButton" :class="buttonClasses">
        {{ buttonLabel }}
      </button>
    </a>
  </div>
</template>

<script>
import cookies from 'js-cookie';
import { mapGetters } from 'vuex';
import TechnologyAI from './assets/svg/tech-responsive-artificial-intelligence.svg?vue-component';
import BlackFridayFonts from './components/BlackFridayFonts';
import GlitchFont from './components/GlitchFont';
import CounterWithDiscount from './CounterWithDiscount';
import CloseIcon from './assets/svg/icon-close.svg?vue-component';
import {
  countDownToDate, calculateSubscriptionsLeft, getPromotion, dateInRightInterval,
} from './utils/helper';
import { CAMPAIGN_PROMOTIONS } from './utils/campaigns';
import LogoPremiumAnnual from './assets/svg/365-logo-premium3.svg?vue-component';

export default {
  components: {
    TechnologyAI,
    CloseIcon,
    BlackFridayFonts,
    GlitchFont,
    CounterWithDiscount,
    LogoPremiumAnnual,
  },
  props: {
    bannerType: { type: Array, default: () => [] },
    side: Boolean,
  },
  data() {
    return {
      visible: (!cookies.get('hideBanners') || this.$config.project === 'site') && this.$store.getters['auth/user'].role !== 'business-student' && this.$store.getters['auth/user'].role !== 'business-admin',
      plans: ['monthly', 'quarterly', 'annual'],
      countdown: {
        days: '00',
        hours: '00',
        minutes: '00',
        seconds: '00',
      },
      impression: false,
      currentDiscount: {},
      promotion: {},
      currentDate: new Date(),
    };
  },
  computed: {
    ...mapGetters({ banner: 'banners/active' }),
    countdownCurrentDiscount() {
      if (this.$store.state.layout === 'mobile') {
        return 'Discount';
      }

      return 'Current Discount';
    },
    discountLogo() {
      const prefix = this.$config.platform.toUpperCase();
      if (this.$store.state.layout === 'mobile') {
        return `${prefix}CMLifetimeDiscountMobile`;
      }

      return `${prefix}CMLifetimeDiscount`;
    },
    bannerClass() {
      const classes = [this.$config.project];
      if (this.banner.typeName) {
        classes.push(`${this.banner.typeName}-offer`);
      }

      if (this.$store.state.campaign) {
        classes.push('banner-campaign');
      }

      // if (this.$store.state.campaign === 'free-access-2024') {
      //   classes.push('counter-dots');
      // }

      classes.push(this.$config.platform);

      if (this.$store.state.campaign && (this.banner.typeName === 'promo' || !this.banner.typeName)) {
        classes.push(this.$store.state.campaign);

        if (this.promotion.extend) {
          classes.push('extend');
        }
      }

      if (this.promotion.className) {
        classes.push(this.promotion.className);
      }

      if (this.banner.typeName === 'collection' && this.$store.getters['auth/user'].simpleLms) {
        classes.push('simple-lms');
      }

      return classes;
    },
    showBannerButton() {
      if (this.$config.project === 'lms' && this.$config.campaign === 'free-access-2024') {
        return false;
      }

      return (this.$config.project !== 'lms' && this.$config.campaign === 'free') || (this.$config.campaign !== 'free')
      || (this.$config.project !== 'lms' && this.$config.campaign === 'black-friday') || (this.$config.campaign !== 'black-friday');
    },
    sideBanner() {
      return this.$route.path.includes('/qa-hub/') || this.$route.path.includes('/courses/');
    },
    userFree() {
      return this.$store.getters['subscriptions/active'] && this.$store.getters['subscriptions/active'].plan.free;
    },
    counterClass() {
      if (this.$store.state.campaign === 'jumpstart-2025') {
        return 'filled discount-extended';
      }

      if (['learn-data-and-ai', 'learn-data-and-ai-new', 'learn-finance'].includes(this.$store.state.campaign)) {
        return 'filled';
      }

      if (['future-proof-2024', 'fast-track-2024'].includes(this.$store.state.campaign)) {
        return 'filled no-border';
      }

      return '';
    },
    buttonClasses() {
      const classes = [];

      if (this.$store.state.campaign) {
        classes.push(`btn-primary btn-lg btn-${this.$store.state.campaign}`);
      } else if (this.banner.type === 0) {
        classes.push('btn-primary-purple');
      } else {
        classes.push('btn-primary-purple-dark');
      }

      if (this.banner.typeName) {
        classes.push(`btn-${this.banner.typeName}-offer`);
      }

      return classes;
    },
    buttonLabel() {
      if (['future-proof-2024', 'fast-track-2024'].includes(this.$store.state.campaign)) {
        return 'Buy Annual Plan';
      }
      if (this.$config.platform === 'fa' && this.$store.state.campaign === 'most-wanted-2024') {
        return 'Buy Now';
      }
      if (this.promotion && this.promotion.btn) {
        return this.promotion.btn;
      }
      if (this.promotion && this.promotion.discount) {
        return `Grab ${this.promotion.discount}% OFF`;
      }
      if (this.discount.btn) {
        return this.discount.btn;
      }

      return this.banner.button;
    },
    discount() {
      return this.currentDiscount;
    },
    subscriptionsLeft() {
      if (this.$store.state.campaign === 'one-of-two-hundred-2024') {
        return calculateSubscriptionsLeft(this.currentDate, this.promotion);
      }

      return 0;
    },
  },
  watch: {
    async $route() {
      if (this.banner) {
        this.visible = (!cookies.get('hideBanners') || this.$config.project === 'site') && this.$store.getters['auth/user'].role !== 'business-student' && this.$store.getters['auth/user'].role !== 'business-admin';
        if (this.visible && this.$config.project === 'site') {
          this.addBannerHolderClass();
        }
        this.$store.commit('banners/setClosedByUser', false);
        if (this.bannerType.includes(this.banner.type)) {
          this.$store.dispatch('dataLayer/addEvent', { event: 'promoImpression', value: { ...this.banner, route: this.$route.name } });
        }
      }
    },
    banner() {
      this.initBanner();
    },
  },
  created() {
    if (this.$store.state.campaign) {
      this.getCurrentPromotion();
    }
  },
  mounted() {
    if (this.banner) {
      this.initBanner();
    }
  },
  methods: {
    initBanner() {
      this.countdown = countDownToDate(new Date(), new Date(this.promotion.endDate));
      if (this.bannerType.includes(this.banner.type)) {
        this.$store.dispatch('dataLayer/addEvent', { event: 'promoImpression', value: { ...this.banner, route: this.$route.name } });
      }

      if (this.$store.state.campaign) {
        this.getCurrentPromotion();
      }

      const x = setInterval(() => {
        const nowDate = new Date();
        if (this.$store.state.campaign && dateInRightInterval(nowDate)) {
          this.getCurrentPromotion();
          this.currentDate = nowDate;

          if (this.$config.project === 'lms' && this.promotion.refresh) {
            cookies.remove('hideBanners', { domain: this.$config.primaryCookiesDomain });
          }
        }

        this.countdown = countDownToDate(nowDate, new Date(this.promotion.endDate));

        if (nowDate > new Date(this.$convertDBDateToUTC(this.banner.endDate))) {
          clearInterval(x);
          this.$store.dispatch('banners/fetch');
          this.removeBanner();
        }
      }, 1000);
    },
    removeBanner() {
      this.visible = false;
      if (this.$config.project === 'lms') {
        cookies.set('hideBanners', true, { expires: 1, domain: this.$config.primaryCookiesDomain });
      }
      this.$store.commit('banners/toggle', true);
      this.$store.commit('banners/setClosedByUser', true);
      if (process.client) {
        const bannerHolder = document.querySelector('main').parentElement;
        if (bannerHolder && bannerHolder.classList.contains('w-banner')) {
          bannerHolder.classList.remove('w-banner');
        }
        const el = document.querySelector('.course-holder');
        if (el && el.classList.contains('lower-content')) {
          el.classList.remove('lower-content');
        }
      }
    },
    getCurrentPromotion() {
      const campaignData = CAMPAIGN_PROMOTIONS[this.$store.state.campaign];
      let promotionData = null;
      if (typeof campaignData === 'function') {
        promotionData = campaignData();
      } else if (typeof campaignData === 'object') {
        promotionData = campaignData;
      }

      if (promotionData) {
        const promoOptions = getPromotion(promotionData.promos, this.promotion, this.$config.platform);

        if (new Date() < promoOptions.lastEndDate) {
          this.promotion = { ...promoOptions.nextPromotion, lastEndDate: promoOptions.lastEndDate, ...CAMPAIGN_PROMOTIONS[this.$store.state.campaign].templates };
        }
      }
    },
    addBannerHolderClass() {
      if (process.client) {
        const bannerHolder = document.querySelector('main').parentElement;
        if (bannerHolder && !bannerHolder.classList.contains('w-banner')) {
          bannerHolder.classList.add('w-banner');
        }
        const el = document.querySelector('.course-holder');
        if (el && !el.classList.contains('lower-content')) {
          el.classList.add('lower-content');
        }
      }
    },
    async click(banner) {
      this.$store.dispatch('dataLayer/addEvent', { event: 'promotionClick', value: { ...this.banner, route: this.$route.name } });

      if (this.$config.project === 'lms' && this.$config.campaign === 'free') {
        return;
      }

      if (this.$store.state.campaign === 'cyber-monday-lifetime-2024' && banner.plan === 3) {
        window.location.href = banner.urlPath;
      } else if (banner.type === 3 && this.$store.getters['auth/user'].simpleLms) {
        this.$router.push('/upgrade/');
      } else if (banner.type === 0 && !this.userFree) {
        this.$router.push('/pricing/');
      } else if (banner.type === 0 || banner.click === 'checkout') {
        this.$store.dispatch('dataLayer/addEvent', { event: 'addToCart', value: banner });

        window.location.href = `${this.$config.siteUrl}/checkout/?plan=${banner.planShortTitle.toLowerCase()}${banner.coupon ? `&coupon=${banner.coupon}` : ''}`;
      } else if (banner.type === 2) {
        if (this.$config.project === 'lms' && !banner.strictUrl) {
          this.$router.push('/pricing/');
        } else {
          window.location.href = banner.urlPath;
        }
      } else {
        window.location.href = banner.urlPath;
      }
    },
  },
};
</script>

<style lang="scss">
$gradient-bg: var(--gradient-banner-trigger);
$gradient-bg-trigger: var(--gradient-banner-trigger-mobile);

@include bp($bp-desktop) {
  .mobile-only,
  .laptop-only {
    display: none;
  }
}

.campaign-1 {
  color: var(--c-fw2024-1);
}

.campaign-2 {
  color: var(--c-fw2024-2);
}

.campaign-3 {
  color: var(--c-fw2024-3);
}

.block {
  display: block;
}

.fa {
  .campaign-fa-1 {
    color: var(--c-fw2024-1);
  }

  .campaign-fa-2 {
    color: var(--c-fw2024-2);
  }

  .campaign-fa-3 {
    color: var(--c-fw2024-3);
  }
}

.banner-holder {
  position: relative;
  text-decoration: none;
  margin: var(--spacing-md) 0;
  text-align: center;
  width: 100%;
  outline: 0;
  appearance: none;
  border: 0;

  &.banner-qa {
    margin-top: 0;
    margin-bottom: 8px;

    .banner.trigger.side {
      padding: var(--spacing-32);

      .counter {
        margin-top: 16px;
      }
    }
  }

  &.banner-dashboard {
    margin-bottom: 64px;
  }

  .close-banner {
    padding: 5px 7px;
    position: absolute;
    top: 12px;
    right: 14px;

    svg {
      cursor: pointer;
      height: 14px;

      path[stroke] {
        stroke: var(--true-white);
      }
    }
  }

  &:not(.banner-campaign) .banner {
    background: var(--main-light-shade-2);
    border: 1px solid var(--main-light-shade-3);
  }

  .banner {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    border-radius: 10px;
    cursor: pointer;

    .banner-header {
      margin: 0;
      text-align: left;
      font-weight: 500;
      color: var(--main-dark-shade-0);
      font-size: 28px;
      line-height: 34px;
    }

    .banner-info {
      text-align: left;
      color: var(--main-dark-light-4);
      margin: 4px 0 0;
    }

    .btn-primary,
    .btn-primary-purple,
    .btn-primary-purple-dark {
      height: 40px;
      color: var(--main-light);
      border: 0;
      outline: 0;
      width: 184px;
      padding: 10px;
    }

    .counter {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      margin-right: 15px;

      .square {
        width: 68px;
        height: 68px;
        box-sizing: border-box;
        border-radius: 8px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: column;
        margin: 0 var(--spacing-4);
        padding: 10px 12px;
        border: 1px solid #B8BFFF;

        span {
          width: 50px;
          color: var(--main-light);

          &.number {
            font-size: 28px;
            line-height: 32px;
          }

          &:last-of-type {
            font-weight: 400;
            font-size: 12px;
            line-height: 20px;
          }
        }
      }

      .square:first-child {
        margin-left: 0;
      }

      .square:last-child {
        margin-right: 0;
      }

      .colon {
        font-size: 32px;
        line-height: 150%;
        color: var(--main-light-shade-2);
      }
    }

    &.trigger {
      padding: var(--spacing-10) 0;
      background: transparent;
      border: none;

      p {
        font-size: 28px;
        line-height: 34px;
        color: var(--main-light);

        &:last-of-type {
          font-size: 16px;
          line-height: 27px;
        }
      }

      &.inline {
        p {
          line-height: 32px;

          &:last-of-type {
            line-height: 20px;
          }
        }
      }
    }

    &.promo,
    &.trigger {
      .banner-header,
      .banner-info {
        color: var(--main-light);
      }

      .btn-primary {
        background: var(--main-dark-light-1);
        color: var(--main-light);
      }
    }

    &.always,
    &.benefit {
      padding: var(--spacing-20) var(--spacing-44);

      &.side {
        padding: var(--spacing-24) var(--spacing-80);

        .banner-header {
          text-align: center;
          margin-bottom: var(--spacing-12);
          font-size: 18px;
        }

        .banner-info {
          margin: 0;
        }

        button {
          margin-top: var(--spacing-8);
        }
      }

      &.inline {
        .banner-header {
          margin: 0;
          font-size: 18px;
          line-height: 26px;
        }

        .icon-slot {
          display: none;
        }
      }
    }

    &.side {
      flex-direction: column;
      padding: var(--spacing-24) var(--spacing-32);

      p {
        text-align: center;
        line-height: 26px;
      }

      .counter {
        margin: var(--spacing-8) 0;
        margin-bottom: 16px;
      }
    }
  }

  &.courses {
    .banner {
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

      &.always.side,
      &.benefit.side {
        .banner-header {
          margin-bottom: var(--spacing-36);
        }
      }

      .icon-slot {
        margin-bottom: 32px;
      }

      .counter {
        margin-top: 16px;

        .square {
          width: 56px;
        }
      }
    }
  }

  &.site {
    >svg {
      path[stroke] {
        stroke: var(--accent-light-3);
      }
    }

    .banner {
      .btn-primary {
        height: 50px;
      }
    }
  }

  &.learn-data-and-ai,
  &.learn-data-and-ai-new,
  &.learn-finance {
    background-color: var(--main-dark);
    background-position: center;
    border-top: 3px solid var(--extreme-yellow);
    border-bottom: 3px solid var(--extreme-yellow);

    .extend-label {
      display: inline-block;
      font-size: 16px;
      font-weight: 700;
      padding: 6px 12px;
      line-height: 18px;
      background-color: var(--c-lda-3);
      margin-bottom: 2px;
    }

    &.ds {
      background-image: url('./assets/images/campaigns/ds-lda-bg-banner.webp');
    }

    &.fa {
      background-image: url('./assets/images/campaigns/fa-lf-bg-banner.webp');
    }

    .block {
      display: block;
    }

    .highlight {
      font-weight: 700;

      &.campaign-1,
      &.blue {
        color: var(--c-lda-2);

        &.special {
          font-weight: 900;
        }
      }

      &.campaign-2,
      &.yellow {
        color: var(--c-lda-1);

        &.special {
          font-weight: 800;
        }
      }

      &.white {
        font-weight: 600;
        color: var(--main-light);
      }
    }

    &.ds .highlight {
      &.blue.special {
        text-shadow: 4px 4px 0 #000C1F;
      }

      &.yellow.special {
        text-shadow: -1px -1px 0 var(--main-dark), 1px -1px 0 var(--main-dark), -1px 1px 0 var(--main-dark), 1px 1px 0 var(--main-dark), 4px 4px 0 var(--c-lda-2);
      }
    }

    a {
      &,
      &:hover {
        color: var(--main-light);
      }
    }

    .banner {
      min-height: 90px;
      border-radius: 0;

      .btn-learn-data-and-ai,
      .btn-learn-data-and-ai-new,
      .btn-learn-finance {
        width: 100%;
        max-width: 220px;
        height: 58px;
        background-color: var(--extreme-yellow);
        color: var(--main-dark);
        border-radius: 0;
        border: 2px solid var(--main-dark);
        font-size: 18px;
        font-weight: 600;
        box-shadow: 6px 6px 0 0 var(--c-lda-2);
      }
    }

    .header-wrap {
      text-align: left;
      font-size: 28px;
      line-height: 30px;

      .highlight {
        font-size: 40px;

        &.blue {
          font-size: 52px;

          .smaller {
            font-size: 40px;
          }
        }
      }
    }

    .counter .square {
      border-radius: 0;
      border: 2px solid var(--c-lda-2);
    }

    &.extend {
      .highlight.yellow.special {
        text-shadow: 4px 4px 0 var(--main-dark);
      }

      .header-wrap .block {
        display: inline;
      }

      .banner {
        .btn-learn-data-and-ai,
        .btn-learn-data-and-ai-new,
        .btn-learn-finance {
          box-shadow: 6px 6px 0 0 var(--c-lda-3);
        }
      }
    }
  }

  &.future-proof-2024,
  &.fast-track-2024 {
    background-image: url('./assets/images/campaigns/ds-fp2024-bg-banner.webp');
    background-color: var(--main-dark);
    background-position: center;
    border-top: 3px solid var(--extreme-yellow);
    border-bottom: 3px solid var(--extreme-yellow);

    .highlight {
      font-weight: 700;

      &.campaign-1,
      &.blue {
        color: var(--c-ft2024-1);
      }

      &.campaign-2,
      &.yellow {
        color: var(--c-ft2024-2);
      }

      &.white {
        font-weight: 600;
        color: var(--main-light);
      }
    }

    a {
      &,
      &:hover {
        color: var(--main-light);
      }
    }

    .banner {
      min-height: 90px;
      border-radius: 0;

      .btn-future-proof-2024,
      .btn-fast-track-2024 {
        width: 100%;
        max-width: 220px;
        height: 58px;
        background-color: var(--extreme-yellow);
        color: var(--main-dark);
        font-size: 18px;
        font-weight: 600;
      }
    }

    .header-wrap {
      text-align: left;

      &.fa {
        font-size: 24px;
        line-height: 32px;

        .bg-highlight {
          background-color: var(--main-light-shade-3);
          color: var(--main-dark);
          border: 1px solid var(--main-dark-light-4);
          padding: 0 8px;
          line-height: 1;
          border-radius: 6px;
        }

        .block {
          display: block;
        }

        .highlight {
          font-size: 32px;

          &.yellow {
            font-size: 40px;
          }
        }
      }

      .code-block img {
        display: block;
        height: 28px;
      }

      .bottom {
        font-size: 28px;
        font-weight: 700;
        line-height: 1.1;
        margin-top: 4px;

        .highlight.blue {
          color: var(--extreme-blue-2);
          text-shadow: 2px 2px 4px rgba(25, 245, 238, 0.5);
        }

        .highlight.yellow {
          color: var(--extreme-yellow);
        }
      }
    }
  }

  &.most-wanted-2024 {
    display: flex;
    height: 96px;
    border-top: 4px solid var(--c-mw-1);
    border-bottom: 4px solid var(--c-mw-1);
    background-color: var(--main-dark);
    background-position: center;
    background-image: url('./assets/images/campaigns/ds-mw-bg-banner.webp');

    &.fa {
      border-color: var(--c-tyf-2);
      background-image: url('./assets/images/campaigns/fa-mw-bg-banner.webp');

      .btn-primary {
        border-radius: 0;
      }
    }

    .header-wrap {
      color: var(--main-light);
      text-align: left;

      &.ds {
        display: flex;
        align-items: center;

        img {
          display: block;
          height: 38px;
          margin-left: -12px;
        }

        .laptop-only {
          display: none;
        }

        .left {
          font-size: 24px;
          font-weight: 700;
          line-height: 1.1;
        }

        .right {
          margin-left: 18px;
          font-size: 68px;
          font-weight: 800;
          line-height: 1.1;
          text-shadow: 0 0 7.6px #FF36FF, -2.119px -1.59px 0 #FF36FF, 1.59px 2.119px 0 #25F4EE;
        }
      }

      &.fa {
        display: flex;
        align-items: center;

        .left {
          line-height: 30px;

          .block {
            display: flex;
            align-items: center;
            font-size: 28px;
            line-height: 20px;

            img {
              display: block;
              height: 29px;
              margin-left: 4px;
            }
          }

          .highlight {
            font-size: 24.5px;
            font-weight: 900;
          }
        }

        .right {
          font-size: 44px;
          font-weight: 800;
          margin-left: 40px;
        }

        &.extend:not(.lms) {
          .left .block {
            line-height: 38px;
          }
        }
      }

      .line-1 {
        font-size: 18px;
        font-weight: 400;

        .bigger {
          font-size: 24px;
        }

        .highlight {
          font-size: 24px;
          font-weight: 600;

          ~ .highlight {
            font-size: 28px;
            font-weight: 700;
          }
        }

        b {
          font-size: 24px;
          font-weight: 900;
        }
      }

      .line-2 {
        margin-top: 5px;
        font-size: 18px;
        font-weight: 400;

        .bigger {
          font-size: 21px;
        }

        b {
          font-size: 21px;
          font-weight: 900;
        }

        .highlight {
          font-size: 21px;
          font-weight: 800;
        }
      }

      &.extend {
        &.ds,
        &.fa {
          img {
            height: 36px;
          }

          img.extend-stamp {
            display: block;
            height: 24px;
            margin-left: 0;
          }

          .left {
            line-height: 1;
          }
        }
      }
    }

    &.banner-holder .banner {
      &.promo .btn-primary {
        background-color: var(--c-mw-2);
        color: var(--main-dark);
        border: 1px solid var(--main-dark);
        transition: all 50ms ease;

        &:hover {
          outline: 2px solid var(--main-dark);
        }
      }

      .counter {
        width: 100%;
        max-width: 280px;
        margin-top: 0;
        margin-bottom: 0;

        .square {
          border: none;

          &:before {
            color: var(--main-light);
          }

          .number {
            font-weight: 700;
            text-shadow: 0 0 8px var(--c-tyf-1);
          }
        }
      }
    }

    &.lms.banner-holder .banner {
      &.promo .btn-primary {
        margin-right: 20px;
      }
    }

    .btn-primary.btn-most-wanted-2024 {
      width: 220px;
      height: 58px;
      font-size: 18px;
      font-weight: 600;
    }
  }

  &.transform-your-future-2024 {
    display: flex;
    height: 96px;
    border-top: 4px solid var(--c-tyf-1);
    border-bottom: 4px solid var(--c-tyf-1);
    background-color: var(--main-dark);
    background-position: center;
    background-image: url('./assets/images/campaign-transform-your-future-2024/ds-tyf-bg-banner.webp');

    &.fa {
      border-color: var(--c-tyf-2);
      background-image: url('./assets/images/campaign-transform-your-future-2024/fa-tyf-bg-banner.webp');
    }

    .header-wrap {
      line-height: 1.1;
      color: var(--main-light);
      text-align: left;

      .line-1 {
        font-size: 18px;
        font-weight: 400;

        .bigger {
          font-size: 24px;
        }

        .highlight {
          font-size: 24px;
          font-weight: 600;

          ~ .highlight {
            font-size: 28px;
            font-weight: 700;
          }
        }

        b {
          font-size: 24px;
          font-weight: 900;
        }
      }

      .line-2 {
        margin-top: 5px;
        font-size: 18px;
        font-weight: 400;

        .bigger {
          font-size: 21px;
        }

        b {
          font-size: 21px;
          font-weight: 900;
        }

        .highlight {
          font-size: 21px;
          font-weight: 800;
        }
      }
    }

    &.banner-holder .banner {
      &.promo .btn-primary {
        background-color: var(--c-tyf-2);
        color: var(--main-dark);
        border: 1px solid var(--main-dark);
        transition: all 50ms ease;

        &:hover {
          outline: 2px solid var(--main-dark);
        }
      }

      .counter {
        width: 100%;
        max-width: 327px;
        margin-top: 0;
        margin-bottom: 0;

        .square {
          border: none;

          &:before {
            color: var(--main-light);
          }

          .number {
            font-weight: 700;
            text-shadow: 0 0 8px var(--c-tyf-1);
          }
        }
      }
    }

    &.lms.banner-holder .banner {
      &.promo .btn-primary {
        margin-right: 20px;
      }
    }

    .btn-primary.btn-transform-your-future-2024 {
      width: 220px;
      height: 58px;
      font-size: 18px;
      font-weight: 600;
    }
  }

  &.cyber-monday-2023 {
    background-color: var(--main-dark);
    background-position: center;
    height: 110px;

    &:before {
      content: '';
      display: block;
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      z-index: -1;
      background-image: url('./assets/images/campaign-cyber-monday-2023/ds-cm-bg-banner.webp');
      background-repeat: no-repeat;
      background-position: center;
      background-size: auto 102px;
    }

    &:after {
      content: '';
      display: block;
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background: linear-gradient(270deg, var(--c-cm-1) 21.64%, var(--c-cm-2) 93.03%);
      z-index: -2;
    }

    &.fa {
      &:before {
        background-image: url('./assets/images/campaign-cyber-monday-2023/fa-cm-bg-banner.webp');
      }

      .header-wrap .main strong {
        color: var(--c-cm-1);
      }
    }

    .header-wrap {
      text-align: left;
      color: var(--main-light);
      display: flex;
      align-items: center;

      .img {
        height: 46px;

        img {
          display: block;
          max-height: 100%;
        }
      }

      .main {
        margin-left: var(--spacing-8);
        display: block;
        font-size: 22px;
        font-weight: 500;
        line-height: 26px;

        strong {
          display: block;
          font-size: 28px;
          color: var(--c-cm-2);
        }
      }
    }

    .banner {
      height: 100%;

      .counter .square {
        border: none;
        font-weight: 500;

        .number {
          font-weight: 700;
        }
      }
    }

    .btn-primary.btn-cyber-monday-2023 {
      width: 220px;
      height: 58px;
      background-color: var(--c-cm-1);
      color: var(--main-light);
      border: 1px solid var(--main-dark);
      font-size: 18px;
      font-weight: 600;
    }

    .counter .square {
      color: var(--main-light);
    }

    &.extend {
      .ext-label {
        width: 153px;
        margin-right: 20px;
      }

      .btn-primary.btn-cyber-monday-2023 {
        background-color: var(--c-cm-3);
        color: var(--main-dark);
        border: 1px solid var(--main-dark);
        font-size: 18px;
        font-weight: 600;
      }
    }
  }

  &.black-friday-2023 {
    background-color: var(--main-dark);
    background-position: center;
    border-top: 4px solid transparent;
    border-bottom: 4px solid transparent;

    &.ds {
      background-image: url('./assets/images/campaign-black-friday-2023/ds-bf-bg-banner.webp');
      border-color: var(--c-bf-2);
    }

    &.fa {
      background-image: url('./assets/images/campaign-black-friday-2023/fa-bf-bg-banner.webp');
      border-color: var(--c-bf-1);
    }

    .header-wrap {
      text-align: left;
      color: var(--main-light);
      display: flex;
      align-items: center;

      .img {
        height: 78px;
        margin-left: -17px;

        img {
          display: block;
          max-height: 100%;
        }
      }

      .main {
        display: block;
        font-size: 22px;
        font-weight: 500;
        line-height: 26px;

        strong {
          display: block;
          font-size: 28px;
          color: var(--c-bf-1);
        }
      }
    }

    .banner {
      height: 102px;

      .counter .square {
        border: none;
        font-weight: 500;
      }
    }

    .btn-primary.btn-black-friday-2023 {
      width: 220px;
      height: 58px;
      background-color: var(--c-bf-1);
      color: var(--main-dark);
      border: 1px solid var(--main-dark);
      font-size: 18px;
      font-weight: 600;
    }
  }

  &.jumpstart-2025 {
    background-color: var(--main-dark);
    background-position: center;
    background-size: auto;

    &.ds {
      background-image: url('./assets/images/campaigns/ds-js2025-bg-banner.webp');
    }

    &.fa {
      background-image: url('./assets/images/campaigns/fa-js2025-bg-banner.webp');

      .header-wrap .highlight {
        &.white {
          text-shadow: 0px 0px 12px var(--accent);
        }

        &.blue {
          color: var(--c-js2025-3);
          text-shadow: none;
        }
      }
    }

    &:before,
    &:after {
      content: '';
      position: absolute;
      display: block;
      left: 0;
      right: 0;
      height: 3px;
      background: linear-gradient(90deg, var(--c-js2025-1) 0%, var(--c-js2025-3) 100%);
    }

    &:before {
      top: 0;
    }

    &:after {
      bottom: 0;
    }

    .banner {
      min-height: 96px;
      color: var(--main-light);

      .counter-with-discount.discount-extended {
        margin-bottom: 0;
        border: 2px solid var(--c-js2025-2);
        max-width: fit-content;
        background-color: var(--main-dark);

        .square {
          flex: 0 0 auto;
          width: 84px;
          height: 66px;
          border-radius: 0;
          margin-right: 0;
          padding-left: 16px;
          padding-right: 16px;

          &.discount {
            white-space: nowrap;
            width: auto;
            border-right: 2px solid var(--c-js2025-2);
            font-size: 40px;
            font-weight: 700;
            color: var(--c-js2025-2);
            text-shadow: 0 0 12px var(--c-js2025-2);

            > span:not(.display-text) {
              line-height: 30px;
            }

            .display-text {
              color: var(--main-light);
              font-weight: 600;
              text-shadow: none;
            }
          }

          &:not(.discount) {
            .display-text {
              color: var(--main-light-shade-2);
            }
          }

          .number {
            font-size: 28px;
            line-height: 30px;
          }
        }
      }
    }

    .header-wrap {
      font-size: 20px;
      font-weight: 400;
      line-height: 1;
      text-align: left;

      .mobile-only {
        display: none;
      }

      .highlight {
        font-weight: 900;
        text-shadow: 0px 0px 12px rgba(37, 244, 238, 0.5);

        &.white {
          color: var(--main-light);
          font-size: 40px;
        }

        &.blue {
          color: var(--c-js2025-1);
          font-size: 28px;
        }
      }
    }

    .btn-primary.btn-jumpstart-2025 {
      width: 220px;
      height: 58px;
      background-color: var(--c-cml2024-2);
      border-radius: 0;
      color: var(--main-dark);
      border: 2px solid var(--main-dark);
      font-size: 18px;
      font-weight: 600;
    }
  }

  &.cyber-monday-lifetime-2024 {
    background-color: var(--main-dark);
    background-position: center;
    border-top: 4px solid var(--c-cml2024-2);
    border-bottom: 4px solid var(--c-cml2024-2);

    .highlight {
      &.blue {
        color: var(--c-cml2024-1);
      }

      &.yellow {
        color: var(--c-cml2024-2);
      }
    }

    &.ds {
      background-image: url('./assets/images/campaigns/ds-cml2024-bg-banner.webp');
    }

    &.fa {
      background-image: url('./assets/images/campaigns/fa-cml2024-bg-banner.webp');
      border-color: var(--c-cml2024-3);

      .btn-primary.btn-cyber-monday-lifetime-2024 {
        border: 2px solid var(--main-dark);
      }
    }

    .banner {
      height: 88px;
      color: var(--main-light);

      .counter {
        margin-bottom: 0;

        .square {
          position: relative;
          border-radius: 0;
          border: 2px solid var(--c-cml2024-2);
          background-color: var(--main-dark);
        }
      }
    }

    .header-wrap {
      display: flex;
      align-items: center;

      .highlight {
        &.white {
          font-size: 48px;
          font-weight: 800;
          line-height: 0.9;
        }
      }

      .block {
        display: block;
        font-size: 20px;
        font-weight: 700;
        text-align: right;
      }

      svg {
        margin-left: 12px;
        height: 65px;
      }
    }

    .btn-primary.btn-cyber-monday-lifetime-2024 {
      width: 220px;
      height: 58px;
      background-color: var(--c-cml2024-2);
      border-radius: 0;
      color: var(--main-dark);
      border: none;
      font-size: 18px;
      font-weight: 600;
    }
  }

  &.cyber-monday-2024 {
    background-color: var(--main-dark);
    background-position: center;
    border-top: 4px solid var(--c-cm2024-2);
    border-bottom: 4px solid var(--c-cm2024-2);

    .highlight {
      &.blue {
        color: var(--c-cm2024-1);
      }

      &.yellow {
        color: var(--c-cm2024-2);
      }
    }

    &.ds {
      background-image: url('./assets/images/campaigns/ds-cm2024-bg-banner.webp');
    }

    &.fa {
      background-image: url('./assets/images/campaigns/fa-cm2024-bg-banner.webp');
      border-color: var(--c-cm2024-3);

      .btn-primary.btn-cyber-monday-2024 {
        border: 2px solid var(--main-dark);
      }
    }

    .banner {
      height: 88px;
      color: var(--main-light);

      .counter {
        margin-bottom: 0;

        .square {
          position: relative;
          border-radius: 0;
          border: 2px solid var(--c-cm2024-3);
          background-color: var(--main-dark);
        }
      }
    }

    .header-wrap {
      display: flex;
      align-items: center;
      text-align: left;

      .block {
        display: block;
      }

      .highlight {
        &.yellow {
          font-size: 91.3px;
          font-weight: 900;
          margin-right: 12px;

          .smaller {
            display: inline-block;
            font-size: 55.6px;
            line-height: 0.8;

            .off {
              font-size: 27px;
            }
          }
        }

        &.blue {
          font-size: 48px;
          font-weight: 800;
          line-height: 0.9;
        }
      }
    }

    .btn-primary.btn-cyber-monday-2024 {
      width: 220px;
      height: 58px;
      background-color: var(--c-fw2024-2);
      border-radius: 0;
      color: var(--main-dark);
      border: none;
      font-size: 18px;
      font-weight: 600;
    }
  }

  &.black-friday-2024 {
    background-color: var(--main-dark);
    background-position: center;
    border-top: 4px solid var(--c-bf2024-2);
    border-bottom: 4px solid var(--c-bf2024-2);

    .highlight {
      &.red {
        color: var(--c-bf2024-1);
      }

      &.yellow {
        color: var(--c-bf2024-2);
      }
    }

    &.ds {
      background-image: url('./assets/images/campaigns/ds-bf2024-bg-banner.webp');

      .banner .counter .square {
        border: 2px solid var(--c-bf2024-1);
      }
    }

    &.fa {
      background-image: url('./assets/images/campaigns/fa-bf2024-bg-banner.webp');

      .banner .counter .square {
        border: 2px solid var(--c-bf2024-2);
      }
    }

    .banner {
      height: 88px;
      color: var(--main-light);

      .counter {
        margin-bottom: 0;

        .square {
          position: relative;
          border-radius: 0;
          background-color: var(--main-dark);
        }
      }
    }

    .header-wrap {
      display: flex;
      align-items: center;
      text-align: left;

      .block {
        display: block;
      }

      .highlight {
        &.yellow {
          font-size: 91.3px;
          font-weight: 900;
          margin-right: 12px;

          .smaller {
            display: inline-block;
            font-size: 55.6px;
            line-height: 0.8;

            .off {
              font-size: 27px;
            }
          }
        }

        &.red {
          font-size: 54px;
          font-weight: 800;
          line-height: 0.9;
        }
      }
    }

    .btn-primary.btn-black-friday-2024 {
      width: 220px;
      height: 58px;
      background-color: var(--c-fw2024-2);
      border-radius: 0;
      color: var(--main-dark);
      border: 1px solid var(--main-dark);
      font-size: 18px;
      font-weight: 600;
    }
  }

  &.free-weeks-2024 {
    background-color: var(--main-dark);
    background-position: center;
    border-top: 4px solid var(--c-fw2024-2);
    border-bottom: 4px solid var(--c-fw2024-2);

    &.ds {
      background-image: url('./assets/images/campaigns/ds-fw2024-bg-banner.webp');
    }

    .banner {
      height: 88px;
      color: var(--main-light);

      .counter {
        margin-bottom: 0;

        .square {
          position: relative;
          border-radius: 0;
          border: 2px solid var(--c-fw2024-1);
          background-color: var(--main-dark);
        }
      }
    }

    .header-wrap {
      display: flex;
      align-items: center;
      font-size: 28px;
      font-weight: 500;
      text-align: right;
      line-height: 0.9;

      div {
        margin-top: 8px;
      }

      .highlight {
        font-size: 40px;
        font-weight: 800;
      }

      .block {
        margin-top: 6px;
      }

      svg {
        height: 70px;
        margin-left: 12px;
      }
    }

    &.fa {
      background-image: url('./assets/images/campaigns/fa-fw2024-bg-banner.webp');
    }

    .btn-primary.btn-free-weeks-2024 {
      width: 220px;
      height: 58px;
      background-color: var(--c-fw2024-2);
      border-radius: 0;
      color: var(--main-dark);
      border: 1px solid var(--main-dark);
      font-size: 18px;
      font-weight: 600;
    }
  }

  &.free-access-2024 {
    background-color: var(--main-dark);
    background-position: center;
    border-top: 4px solid transparent;
    border-bottom: 4px solid transparent;

    &.ds {
      background-image: url('./assets/images/campaigns/ds-fa2024-bg-banner.webp');
      border-color: var(--c-fa2024-2);
    }

    .banner {
      height: 102px;

      .counter {
        margin-bottom: 0;

        .square {
          position: relative;
          border: none;
          background-color: var(--c-fa2024-1);
          box-shadow: 0 0 10px 0 rgba(0, 12, 31, 0.8);

          span {
            color: var(--main-dark);
          }
        }
      }
    }

    .header-wrap {
      text-align: left;
      color: var(--main-light);
      align-items: center;

      .highlight {
        &.blue {
          color: var(--c-fa2024-1);
          font-size: 20px;
          line-height: 20px;
          font-weight: 800;
        }

        &.yellow {
          color: var(--c-fa2024-2);
          margin-top: 6px;
          font-size: 32px;
          line-height: 32px;
          font-weight: 600;
        }
      }

      .line-1 {
        font-size: 32px;
        line-height: 40px;
      }

      .line-2 {
        font-size: 28px;
        line-height: 35px;

        .highlight {
          font-size: 38px;
          line-height: 1.1;
        }
      }
    }

    &.fa {
      background-image: url('./assets/images/campaigns/fa-fa2024-bg-banner.webp');
      border-color: var(--c-fa2024-2);

      .header-wrap {
        .highlight-special {
          text-shadow: 0 0 38px var(--extreme-dark-blue);
        }

        .main .highlight.blue {
          color: var(--accent-light-3);
        }
      }
    }

    .btn-primary.btn-free-access-2024 {
      width: 220px;
      height: 58px;
      background-color: #FAFF00;
      color: var(--main-dark);
      border: 1px solid var(--main-dark);
      font-size: 18px;
      font-weight: 600;
    }
  }

  &.counter-dots {
    .banner .counter .square {
      position: relative;
      border: none;

      + .square:before {
        content: ':';
        font-size: 32px;
        line-height: 32px;
        font-weight: 400;
        color: #FFF;
        opacity: 0.4;
        position: absolute;
        top: 15%;
        left: 50%;
        margin-left: -68%;
      }
    }
  }

  &.get-future-ready {
    background-image: url('./assets/images/campaign-get-future-ready/dsgfr-bg-banner.webp');
    background-color: var(--main-dark);
    background-position: center;
    border-top: 4px solid var(--main-dark-light-3);
    border-bottom: 4px solid var(--main-dark-light-3);

    .highlight-special {
      position: relative;
      line-height: 1.2;
      font-weight: 900;
      text-shadow: 0 3.6274824142456055px 8.809599876403809px rgba(37, 244, 238, 0.5);
      color: var(--extreme-blue-2);
      padding-right: 5px;

      &:after {
        content: attr(title);
        position: absolute;
        color: transparent;
        -webkit-text-stroke: 1px var(--main-light);
        text-shadow: none;
        top: 3px;
        left: 3px;
        z-index: -1;
      }
    }

    .header-wrap {
      text-align: left;
      color: var(--main-light);
      text-transform: uppercase;
      line-height: 1;

      .main {
        display: block;

        .block {
          font-size: 28px;
          color: var(--main-yellow-light-2);
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      .small {
        font-size: 18px;
        font-weight: 500;
      }

      .highlight-special {
        font-size: 32px;
        text-transform: uppercase;
        font-weight: 900;

        &,
        + .small {
          margin-right: 5px;
        }
      }

      .bold {
        font-size: 28px;
        font-weight: 800;
      }
    }
  }

  &.finance-courses-offer,
  &.black-friday {
    .fc-heading,
    .bf-heading {
      display: flex;
      align-items: center;
      margin-right: auto;

      p {
        line-height: 110%;
        font-weight: 800;
        margin: 0;
      }

      .black-friday {
        margin: 0;
        font-size: 30px;
        color: var(--extreme-yellow);
      }

      .limited-time-offer {
        margin: 0;
        font-size: 21px;
        color: #FC1E96;
      }

      .holder-groups {
        width: 50%;
        margin-right: 10px;
      }
    }

    .counter {
      margin: 0 var(--spacing-55);
      padding: 0;

      .square {
        border: 1px solid rgba(25, 245, 238, 0.5);
        backdrop-filter: blur(1.65714px);
        border-radius: 0;
        width: 80px !important;
        height: 58px !important;
        padding: 6px 12px;

        span:first-of-type {
          font-weight: 500;
          font-size: 30px;
          line-height: 100%;
          color: #19F5EE;
        }

        span:last-of-type {
          line-height: 130%;
          color: #19F5EE;
        }
      }
    }

    .btn-primary-purple-dark {
      max-width: 210px;
      width: 100%;
      background: #FCFC53;
      color: var(--main-dark-shade-0);
      border: 0;
      border-radius: 0;
      font-weight: 600;
      font-size: 21px;
      height: 58px;

      &:hover,
      &:active {
        background: #FF8;
      }
    }

    .banner-info {
      display: none;
    }
  }

  &.black-friday {
    background-image: url('./assets/images/sticky-banner-bg.png');
    padding: var(--spacing-24) var(--spacing-140);
    background-color: #010C1E;
    border: solid rgba(25, 95, 245, 0.5);
    border-width: 5px 0;
  }

  &.finance-courses-offer {
    background-image: url('./assets/images/cyber-monday-promo-banner.png');
    background-size: cover;
    background-position: right;
    background-repeat: no-repeat;
    padding-top: 19px;
    padding-bottom: 19px;
    margin: 0;
    text-align: left;

    &:after {
      content: "";
      position: absolute;
      width: 100%;
      height: calc(100% - 10px);
      top: 0;
      left: 0;
      border-image: linear-gradient(to right, rgba(25, 95, 245, 0.5), rgba(25, 245, 238, 0.5)) 30;
      border-width: 5px;
      border-style: solid;
      border-left: none;
      border-right: none;
      display: block;
      z-index: -1;
    }

    .promo {
      .header-wrap {
        width: 519px;

        .fc-heading {
          column-gap: 10px;

          .font-wrapper {
            position: relative;
            top: 2px;
          }

          .finance-courses-offer {
            margin-top: 0;
            font-size: 21px;
            font-weight: 900;
            line-height: 26px;
            color: #19F5EE;
            text-shadow: 0 1.3644px 3.31353px rgba(37, 244, 238, 0.5), 0.974569px 3.11862px 5.45759px #2D0CEC;
          }

          .limited-time-offer {
            font-size: 18px;
          }
        }
      }

      .counter {
        margin: 0 var(--spacing-48);

        .square {
          background: rgba(255, 255, 255, 0.1);
          border: 1px solid rgba(25, 245, 238, 0.5);
          backdrop-filter: blur(5px);
          text-align: center;
        }
      }
    }

    .close-banner {
      mix-blend-mode: overlay;
    }

    &.lms {
      top: 64px;

      .close-banner {
        top: 4px;
        right: 4px;
      }

      .promo {
        border-radius: 0;
        overflow: hidden;

        &.small {
          @media screen and (max-width: 1440px) {
            flex-wrap: wrap;
            justify-content: center;
            row-gap: 4px;

            .header-wrap {
              flex-basis: 100%;
              display: flex;
              justify-content: center;

              .fc-heading {
                margin: 0;

                .font-wrapper,
                + div {
                  transform: scale(0.85);
                }
              }
            }

            .counter {
              margin-right: var(--spacing-36);
            }
          }
        }

        .header-wrap {
          width: 530px;

          .fc-heading {
            .cm-font-wrapper {
              padding-right: 0;
            }

            .finance-courses-offer {
              font-weight: 900;
            }

            .limited-time-offer {
              font-size: 18px;
            }
          }
        }

        .counter {
          margin: 0;
        }
      }
    }
  }

  &.top-finance-training {
    height: 96px;

    &:before,
    &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
    }

    &:before {
      background-image: url('./assets/images/banners/tft-site-banner-bg.webp');
      z-index: -1;
    }

    &:after {
      background-image: url('./assets/images/banners/tft-site-banner-bg-last-promo.webp');
      z-index: -2;
    }

    a {
      padding: var(--spacing-16) 0;

      .header-wrap .title {
        .main {
          margin: 0;
          color: var(--main-light);
          font-weight: 900;
          font-size: 29px;
          line-height: 23px;
          text-transform: uppercase;
          text-shadow: 0 1.87612px 4.55629px #358CFD, 0 0 7.50449px #358CFD;
        }

        .subtitle {
          text-align: left;
          margin: 15px 0 0;
          font-weight: 900;
          font-size: 22px;
          line-height: 19px;
          text-transform: uppercase;
          text-shadow: 0 1.56188px 3.79314px #358CFD, 0 0 6.24752px #358CFD;
          color: var(--main-light);
          display: flex;

          .highlighted {
            font-size: 33px;
            line-height: 26px;
            text-transform: uppercase;
            color: #358CFD;
            text-shadow: none;
            margin-left: 9px;
          }
        }
      }

      .counter-with-discount {
        width: 386px;
        height: 64px;
        border: 1px solid #358CFD;
        border-radius: 10px;

        .square {
          border: none;
          padding: var(--spacing-10) var(--spacing-12);

          span {
            color: #F0F0F2;
            font-size: 24px;
            line-height: 26px;

            &.display-text {
              font-size: 14px;
              color: #F0F0F2;
              margin: 0;
              line-height: 18px;
            }
          }

          &.discount {
            width: 142px;
            margin: 2px var(--spacing-10) 2px 0;
            padding: var(--spacing-8) var(--spacing-12);
            border-radius: 0;
            border-right: 1px solid #358CFD;

            span {
              font-weight: 700;
              line-height: 28px;
              text-transform: uppercase;
              color: var(--main-light);
              text-shadow: 0 3.47052px 8.42841px #036FFD, 0 0 13.8821px #036FFD;

              &.display-text {
                width: 118px;
                font-weight: 600;
                line-height: 100%;
                letter-spacing: 0.02em;
                text-transform: capitalize;
                text-shadow: none;
              }
            }
          }

          &.minutes {
            margin-right: 0;
          }
        }
      }
    }

    .btn-top-finance-training {
      width: 210px;
      height: 58px;
      background-color: var(--main-yellow);
      font-weight: 600;
      font-size: 21px;
      color: var(--main-dark);

      &:hover {
        background-color: var(--main-yellow-shade-1);
      }

      &:active {
        background-color: var(--main-yellow-shade-2);
      }
    }

    .close-banner {
      svg {
        path[stroke] {
          stroke: var(--main-dark-light-4);
        }
      }
    }

    &.last-promo,
    &.last-promo.lms {
      &:before {
        display: none;
      }

      a {
        padding: 13px 0;

        .header-wrap .title {
          .main {
            text-align: left;
            font-size: 32px;
            line-height: 37px;
            text-shadow: 0 1.96482px 4.77171px #036FFD, 0 0 7.85928px #036FFD;
          }

          .subtitle {
            margin-top: 0;
            font-weight: 400;
            text-transform: none;
            text-shadow: none;
            font-size: 25px;
            line-height: 100%;
            letter-spacing: 0.015em;
            align-items: center;

            .highlighted {
              font-weight: 900;
              font-size: 28px;
              line-height: 33px;
              text-transform: uppercase;
              color: var(--accent-light-3-400);
            }
          }
        }
      }
    }
  }

  &.top-finance-training.lms {
    a {
      &.small {
        @media screen and (max-width: 1480px) and (min-width: 1440px) {
          .btn-top-finance-training {
            margin-right: 20px;
          }
        }
      }

      .header-wrap .title {
        .main {
          font-size: 28.5px;
        }

        .subtitle .highlighted {
          font-size: 31.5px;
        }
      }

      .counter-with-discount {
        .square {
          &.discount {
            span {
              &.display-text {
                width: 122px;
              }
            }
          }
        }
      }
    }
  }

  &.free-days {
    display: flex;
    align-items: center;

    a {
      max-height: 92px;

      .header-wrap {
        .fd-heading {
          display: flex;

          .left-side {
            display: flex;
            flex-direction: row;

            span {
              display: flex;
              align-items: center;
              justify-content: center;
              font-weight: 800;

              &:not(.banner-highlight) {
                line-height: 100%;
                font-size: 52px;
                color: var(--main-dark);
                margin-right: 9px;
              }

              &.banner-highlight {
                width: 36px;
                height: 58px;
                margin-right: var(--spacing-4);
                background: var(--main-dark);
                border-radius: 5px;
                font-size: 32px;
                line-height: 110%;
                text-transform: capitalize;
                color: var(--accent-light-3-400);
                text-shadow: 0 0 20px var(--accent-light-3);

                &:last-of-type {
                  margin-right: 0;
                }
              }
            }
          }

          .right-side {
            margin-left: 9px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            color: var(--main-dark);

            .top-part {
              font-weight: 600;
              font-size: 26px;
              line-height: 110%;
              margin-bottom: 3px;
            }

            .bottom-part {
              font-weight: 600;
              font-size: 19px;
              line-height: 110%;
            }
          }
        }
      }

      .counter {
        .square {
          width: 56px;
          height: 49px;
          padding: 0;
          margin: 0;

          &.days {
            display: none;
          }
        }
      }

      .btn-free-days {
        font-weight: 600;
      }
    }

    .close-banner {
      svg {
        path[stroke] {
          stroke: rgba(1, 22, 51, 0.4);
        }
      }
    }

    &.lms {
      .close-banner {
        @media screen and (max-width: 1310px) {
          right: 6px;
        }
      }
    }
  }

  &.trigger-offer {
    background-image: url(./assets/images/banners/trigger-offer-bg.jpg);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;

    .banner.trigger {
      .banner-header {
        font-weight: 600;
        font-size: 18px;
        line-height: 27px;
        color: var(--main-red-light-2);
      }

      &.inline {
        p:last-of-type {
          font-weight: 600;
          font-size: 26px;
          line-height: 34px;
          margin-top: 0;

          .highlighted {
            font-weight: 800;
          }
        }
      }

      .counter {
        width: 290px;
        margin: 0;

        .square {
          border: 1px solid rgba(255, 255, 255, 0.5);
          width: 66px;
          height: 72px;
        }
      }
    }

    .close-banner {
      top: 8px;
      right: 20px;
      mix-blend-mode: overlay;

      svg {
        path[stroke] {
          stroke: #011633;
        }
      }
    }
  }

  &.collection-offer {
    background: linear-gradient(90deg, #FAE391 -11.39%, #7B61FF 117.22%);
    box-shadow: 0 16px 30px rgba(0, 12, 31, 0.25);
    padding: 10px 0;

    .banner.collection {
      height: 72px;
      background: none;
      border: none;
      justify-content: center;

      .icon-wrap {
        width: 64px;
        height: 64px;
        border: 2.31884px solid var(--main-yellow-light-1);
        border-radius: 100%;
        overflow: hidden;
        margin-right: var(--spacing-16);

        img {
          display: block;
          width: 100%;
        }
      }

      .header-wrap {
        .banner-header-top {
          margin: 0;
          text-align: left;
          font-weight: 600;
          font-size: 18px;
          color: #10141C;
        }

        .banner-header {
          letter-spacing: 0.1px;
          font-weight: 600;
          color: #10141C;

          .highlighted {
            font-weight: 800;
            color: var(--main-purple-dark-1);
          }
        }
      }

      .counter {
        margin: 0 auto;

        .square {
          width: 66px;
          height: 72px;
          border: none;
          position: relative;

          &:after {
            content: '';
            display: block;
            width: 66px;
            height: 72px;
            position: absolute;
            top: 0;
            left: 0;
            border: 1px solid #011633;
            border-radius: 8px;
            mix-blend-mode: overlay;
          }

          span {
            color: #10141C;
            mix-blend-mode: normal;
          }
        }
      }

      .btn-collection-offer {
        background: var(--main-yellow);
        color: #10141C;

        &:hover {
          background: var(--main-yellow-shade-1);
        }

        &:active {
          background: var(--main-yellow-shade-2);
        }
      }
    }

    .close-banner {
      mix-blend-mode: overlay;
      right: 10px;
      top: 2px;

      svg {
        path[stroke] {
          stroke: #000C1F;
        }
      }
    }
  }

  &.collection-offer.simple-lms {
    background: var(--Lights-and-shades-Main-dark, var(--main-dark));
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1);
    border-top: 5px solid;
    border-bottom: 5px solid;
    border-image-slice: 1;
    border-image-source: linear-gradient(80deg, #EDC843 0%, #FF5050 50%, #7B61FF 100%);

    .banner.collection {
      height: 86px;

      .header-wrap {
        .banner-header {
          color: var(--main-light);
          line-height: 25px;
          font-size: 24px;

          .highlighted {
            color: var(--main-yellow);
            text-transform: uppercase;
          }

          .new-line {
            display: block;
          }
        }
      }

      .counter .square {
        background-color: rgba(255, 255, 255, 0.2);

        span {
          color: var(--main-light);
        }

        &:before {
          content: none;
        }
      }
    }

    .close-banner {
      mix-blend-mode: normal;

      svg {
        path[stroke] {
          stroke: var(--main-dark-shade-4);
        }
      }
    }
  }

  &.one-of-two-hundred-2024 {
    height: 96px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;

    &.ds {
      background-image: url('./assets/images/campaigns/ds-oth-bg-banner.webp');
    }

    &.fa {
      background-image: url('./assets/images/campaigns/fa-oth-bg-banner.webp');
    }

    &.ds:before,
    &.ds:after {
      content: '';
      display: block;
      position: absolute;
      width: 100%;
      height: 3px;
      background: rgba(252, 30, 150, 0.5);
    }

    &.fa:before,
    &.fa:after {
      content: '';
      display: block;
      position: absolute;
      width: 100%;
      height: 3px;
      background: linear-gradient(90deg, rgba(252, 252, 83, 1) 0%, rgba(252, 252, 83, 1) 35%, rgba(3, 111, 253, 1) 65%, rgba(3, 111, 253, 1) 100%);
    }

    &:before {
      top: 0;
    }

    &:after {
      bottom: 0;
    }

    &.fa .fa-highlighted {
      color: var(--accent-light-3);
    }

    .banner {
      height: 100%;
      padding: var(--spacing-12) 0;

      .header-wrap .title {
        color: var(--main-light);
        text-align: left;

        .line-1 {
          font-weight: 700;
          font-size: 28px;
          line-height: 110%;

          .highlighted {
            display: inline-block;
            color: var(--c-oth-2);
            font-weight: 800;
          }
        }

        .line-2 {
          font-weight: 500;
          font-size: 21px;
          line-height: 110%;

          .subscriptions {
            width: 61px;
            height: 39px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            background: var(--main-dark-light-2);
            border: 1px solid var(--main-dark-light-4);
            border-radius: 10px;
            font-weight: 700;
            color: var(--c-oth-1);
            margin: 0 var(--spacing-12);
          }
        }
      }

      .btn-one-of-two-hundred-2024 {
        width: 210px;
        height: 58px;
        position: relative;
        left: -8px;
        top: -6px;
        font-weight: 600;
        font-size: 21px;
        line-height: 100%;
        letter-spacing: 0.02em;
        cursor: pointer;
        color: var(--main-dark);
        background: var(--c-oth-2);
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition-duration: 320ms;
        box-shadow:
          0 0 0 #B7B700,
          1px 1px 0 #B7B700,
          2px 2px 0 #B7B700,
          3px 3px 0 #B7B700,
          4px 4px 0 #B7B700,
          5px 5px 0 #B7B700,
          6px 6px 0 #B7B700,
          7px 7px 0 #B7B700,
          8px 8px 0 #B7B700;

        &:hover {
          color: var(--main-dark);
          background: #E7E700;
          box-shadow:
            0 0 0 #A7A700,
            1px 1px 0 #A7A700,
            2px 2px 0 #A7A700,
            3px 3px 0 #A7A700,
            4px 4px 0 #A7A700,
            5px 5px 0 #A7A700,
            6px 6px 0 #A7A700,
            7px 7px 0 #A7A700,
            8px 8px 0 #A7A700;
        }

        &:active {
          box-shadow: none;
          transition-duration: 50ms;
          transform: translate(8px, 8px);
        }

        @media screen and (max-width: 1090px) {
          left: -38px;
        }
      }

      @media screen and (min-width: 1440px) and (max-width: 1480px) {
        &.small {
          .btn-one-of-two-hundred-2024 {
            left: -30px;
          }
        }
      }
    }

    .close-banner {
      svg {
        path[stroke] {
          stroke: var(--main-dark-light-4);
        }
      }
    }
  }

  &.campaign-chat-gpt {
    background: url('assets/images/campaign-chat-gpt/campaign-chat-gpt-bg.webp');
    background-position: center;

    .close-banner {
      opacity: 0.4;
    }

    a {
      color: var(--main-light);
    }

    .header-wrap {
      display: flex;
      align-items: center;
      padding: 9px 0;

      .left {
        display: flex;
        align-items: center;
        background-color: var(--main-dark-light-2);
        border-radius: 5px;
        border: 2px solid #56BFC7;
        width: 310px;

        .svg {
          width: 68px;
          height: 68px;
          padding: 13px;
          background-color: var(--main-dark);
          display: flex;
          align-items: center;
          justify-content: center;
          flex: 0 0 auto;
          border-top-left-radius: 5px;
          border-bottom-left-radius: 5px;

          svg {
            width: 100%;
            height: 100%;

            [fill] {
              fill: #16A180;
            }

            [stroke] {
              stroke: #16A180;
            }
          }
        }

        .title {
          font-size: 21px;
          line-height: 20px;
          font-weight: 400;
          min-width: 0;

          strong {
            font-weight: 600;
          }
        }
      }

      .right {
        font-size: 27px;
        line-height: 0.78;
        font-weight: 700;
        margin-left: 20px;

        .highlight {
          display: block;
          color: var(--main-yellow);
          font-size: 40px;
          margin-top: var(--spacing-8);
        }
      }
    }

    .banner {
      border-radius: 0;
      border-top: 3px solid var(--main-yellow);
      border-bottom: 3px solid var(--main-yellow);
      background-color: transparent;
      border: none;

      .counter .square {
        position: relative;
        border: none;

        + .square {
          &:before {
            content: ':';
            font-size: 32px;
            font-weight: 400;
            color: #FFF;
            opacity: 0.4;
            position: absolute;
            top: 15%;
            left: 50%;
            margin-left: -68%;
          }
        }
      }

      .btn-campaign-chat-gpt {
        width: 100%;
        max-width: 220px;
        height: 58px;
        background-color: var(--main-yellow);
        color: var(--main-dark);
        font-size: 18px;
        font-weight: 600;
      }
    }
  }
}

.top-banner {
  position: sticky;
  top: 64px;
  z-index: 10;
  margin: 0;
  border-radius: 0;
  background: $gradient-bg;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

  &.top-finance-training {
    background: var(--main-dark);
  }

  .promo,
  &.free-days > a {
    border: 0;
    background: transparent;

    p:first-child {
      margin-top: 18px;
      margin-bottom: 4px;
    }

    p:last-child {
      margin-bottom: 18px;
    }
  }

  .promo .counter .square {
    width: 66px;
    height: 72px;
  }

  &.bf,
  &.bf.site {
    background: linear-gradient(270deg, #141F31 20.76%, #EDC843 95.76%);

    .banner .btn-primary {
      background-color: var(--main-yellow);

      &:hover {
        background-color: #DFB726;
      }

      &:active {
        background-color: #CEA40A;
      }
    }

    > svg path {
      stroke: var(--main-dark-light-4);
    }
  }

  &.cm,
  &.cm.site {
    background: linear-gradient(270deg, #141F31 16.97%, #FF214D 89.6%);

    .banner .btn-primary {
      background-color: #FF214D;

      &:hover {
        background-color: #E71B43;
      }

      &:active {
        background-color: #CC0B31;
      }
    }
  }

  &.free,
  &.free-days,
  &.free.site {
    background: var(--main-yellow);
    color: var(--main-dark-shade-0);

    .close-banner svg path {
      stroke: var(--main-yellow-shade-2);
    }

    .banner {
      .banner-header {
        color: var(--main-dark-shade-0);
        display: flex;
        align-items: center;

        .percent {
          font-size: 52px;
          font-weight: 700;
          margin-right: 8px;
        }

        .free {
          margin-right: 8px;

          span {
            background: var(--main-dark);
            border-radius: 5px;
            display: inline-block;
            padding: 12.5px 8px;
            line-height: 36px;
            font-weight: 700;
            color: var(--extreme-blue);
            text-shadow: 0 0 20px var(--extreme-blue);
            font-size: 32px;
            max-height: 58px;

            &:not(:last-child) {
              margin-right: 4px;
            }
          }
        }

        .unlimited {
          font-size: 26px;
          line-height: 28px;

          .courses {
            margin-top: 3px;
            font-size: 17px;
            line-height: 18px;
            font-weight: 600;
            display: block;

            .days {
              color: rgba(0, 12, 31, 0.4);
            }
          }
        }
      }

      .counter {
        margin-right: 46px;
        margin-left: auto;

        .square {
          border: none;
          width: 56px;
          position: relative;

          &:not(:last-child) {
            margin-right: 23px;
          }

          &:not(:last-child):after {
            content: ":";
            position: absolute;
            right: -16px;
            top: 45%;
            transform: translateY(-50%);
            font-size: 32px;
            color: rgba(0, 12, 31, 0.4);
          }

          span {
            color: var(--main-dark-shade-0);

            &:first-of-type {
              font-weight: 500;
              font-size: 28px;
            }

            &:last-of-type {
              font-size: 14px;
              line-height: 18px;
              width: auto;
            }
          }
        }
      }

      .btn-primary-purple-dark {
        background-color: var(--main-dark);
        font-size: 18px;
        height: 58px;
        width: 220px;
        flex: 0 0 auto;

        &:hover {
          background-color: var(--main-dark);
        }

        &:active {
          background-color: var(--main-dark);
        }
      }
    }
  }

  &.site {
    z-index: 8;
    position: fixed;
    top: 80px;
  }

  &.free-days {
    .banner {
      .counter {
        margin: 0 auto;
      }
    }
  }
}

@include bp($bp-laptop) {
  .laptop-only {
    display: block;
  }

  .banner-holder {
    &.collection-offer .banner.collection .header-wrap {
      .banner-header-top {
        font-size: 16px;
      }

      .banner-header {
        font-size: 24px;
      }
    }

    &.trigger-offer .banner.trigger.inline p:last-of-type {
      font-size: 24px;
    }

    &.learn-data-and-ai,
    &.learn-data-and-ai-new,
    &.learn-finance {
      .extend-label {
        font-size: 14px;
        line-height: 13px;
      }

      .header-wrap {
        font-size: 24px;

        .highlight {
          &.yellow {
            font-size: 36px;
          }

          &.blue {
            font-size: 48px;

            .smaller {
              font-size: 32px;
            }
          }
        }
      }
    }

    &.jumpstart-2025 {
      &.ds {
        background-image: url('./assets/images/campaigns/ds-js2025-bg-banner-laptop.webp');
      }

      &.fa {
        background-image: url('./assets/images/campaigns/fa-js2025-bg-banner-laptop.webp');
      }

      .header-wrap {
        font-size: 18px;

        &.highlight {
          &.white {
            font-size: 36px;
          }

          &.blue {
            font-size: 24px;
          }
        }
      }
    }

    &.cyber-monday-lifetime-2024 {
      .header-wrap {
        .highlight.white {
          font-size: 40px;
        }
      }
    }

    &.cyber-monday-2024 {
      .header-wrap {
        .highlight {
          &.yellow {
            font-size: 70px;
            font-weight: 900;
            margin-right: 2px;

            .smaller {
              display: inline-block;
              font-size: 44px;
              line-height: 0.8;

              .off {
                font-size: 22px;
              }
            }
          }

          &.blue {
            font-size: 38px;
            font-weight: 800;
            line-height: 0.9;
          }
        }
      }
    }

    &.black-friday-2024 {
      .header-wrap {
        .highlight {
          &.yellow {
            font-size: 70px;
            font-weight: 900;
            margin-right: 2px;

            .smaller {
              display: inline-block;
              font-size: 44px;
              line-height: 0.8;

              .off {
                font-size: 22px;
              }
            }
          }

          &.red {
            font-size: 44px;
            font-weight: 800;
            line-height: 0.9;
          }
        }
      }
    }

    &.free-weeks-2024 {
      .header-wrap {
        font-size: 24px;
        line-height: 0.7;

        .highlight {
          font-size: 32px;
        }

        svg {
          height: 50px;
        }
      }

      .btn-primary.btn-free-weeks-2024 {
        width: 180px;
      }
    }

    &.fast-track-2024 {
      .header-wrap.fa {
        font-size: 21px;

        .highlight {
          font-size: 28px;

          &.yellow {
            font-size: 32px;
          }
        }
      }
    }

    &.top-finance-training,
    &.top-finance-training.lms {
      &:before {
        background-image: url('./assets/images/banners/tft-site-banner-bg-laptop.webp');
        z-index: -1;
        display: block;
      }

      &:after {
        background-image: url('./assets/images/banners/tft-site-banner-bg-laptop-last-promo.webp');
        z-index: -2;
      }

      a .header-wrap .title {
        margin-bottom: var(--spacing-10);

        .main {
          font-size: 24.6px;
          line-height: 20px;
        }

        .subtitle {
          font-size: 18px;
          line-height: 13px;

          .highlighted {
            font-size: 28.4px;
            line-height: 18px;
          }
        }
      }

      .btn-top-finance-training {
        width: 170px;

        @media screen and (min-width: 1024px) and (max-width: 1090px) {
          margin-right: var(--spacing-30);
        }
      }

      &.last-promo {
        &:before {
          display: none;
        }

        a .header-wrap .title {
          margin-bottom: 0;

          .main {
            font-size: 30px;
          }

          .subtitle {
            font-size: 23px;

            .highlighted {
              font-size: 24px;
              margin-left: 7px;
            }
          }
        }
      }
    }

    &.top-finance-training.lms {
      a .header-wrap .title {
        .main {
          font-size: 24px;
        }

        .subtitle .highlighted {
          font-size: 26.7px;
        }
      }
    }

    &.get-future-ready {
      .header-wrap .highlight-special {
        &,
        + .small {
          margin-right: 0;
        }
      }
    }

    &.most-wanted-2024 {
      .header-wrap {
        &.ds {
          img {
            margin-left: -6px;
            height: 66px;
          }

          .desktop-only {
            display: none !important;
          }

          .laptop-only {
            display: block !important;
          }

          .left {
            font-size: 16px;
          }

          .right {
            font-size: 56px;
          }
        }

        &.fa {
          .right {
            margin-left: 20px;
          }
        }

        &.extend {
          &.ds,
          &.fa {
            img {
              height: 58px;
              margin-top: -2px;
              margin-bottom: -2px;
            }

            img.extend-stamp {
              height: 16px;
            }

            .left {
              font-size: 14px;
            }
          }
        }
      }
    }
  }

  .top-banner.free-days {
    .banner {
      .btn-primary-purple-dark {
        width: 160px;
      }
    }
  }
}

@include bp($bp-mobile) {
  $gradient-bg-mobile: var(--gradient-banner-trigger-mobile);

  .desktop-only {
    display: none !important;
  }

  .banner-holder {
    .banner {
      flex-direction: column;
      height: auto !important;
      padding-top: 40px;
      padding-bottom: 20px;

      p {
        text-align: center !important;
      }

      .counter {
        margin: var(--spacing-16) 0;

        .square {
          padding: var(--spacing-xs);
        }
      }

      &.trigger,
      &.promo {
        padding: var(--spacing-32) var(--spacing-16);
      }

      &.promo {
        p {
          line-height: 28px;

          &:first-of-type {
            line-height: 34px;
          }
        }

        .counter .square {
          width: 68px;
          padding: var(--spacing-xs);
        }
      }

      &.always,
      &.benefit {
        padding: 24px 60px 28px;

        &.inline {
          width: 100%;

          .banner-header {
            margin-bottom: 12px;
            font-size: 18px;
            line-height: 26px;
          }

          .icon-slot {
            display: none;
          }

          button {
            width: 184px;
            height: 40px;
            border-radius: 4px;
          }
        }

        button {
          padding: 10px;
          width: 184px;
          height: 40px;
        }
      }

      &.free-days {
        .counter {
          .square {
            padding-left: 0;
            padding-right: 0;
            height: 65px;
            width: 56px;
            margin-right: 33px !important;

            &:last-of-type {
              margin-right: 0 !important;
            }
          }
        }

        p {
          margin: 0;
        }
      }
    }

    &.jumpstart-2025 {
      &.ds {
        background-image: url('./assets/images/campaigns/ds-js2025-bg-banner-mobile.webp');
      }

      &.fa {
        background-image: url('./assets/images/campaigns/fa-js2025-bg-banner-mobile.webp');
      }

      .header-wrap {
        font-size: 20px;
        line-height: 1.1;
        text-align: center;

        .limited-offer {
          font-size: 15px;
          margin-bottom: 12px;
        }

        .mobile-only {
          display: block;
        }

        .highlight {
          &.white {
            font-size: 39px;
          }

          &.blue {
            font-size: 34px;
            display: block;
          }
        }
      }

      .banner {
        min-height: 372px;

        .counter-with-discount.discount-extended {
          .square {
            padding-left: 4px;
            padding-right: 4px;
          }
        }
      }

      .btn-primary.btn-jumpstart-2025 {
        margin-top: 16px;
        margin-bottom: 12px;
        width: 100%;
        max-width: 327px;
      }
    }

    &.cyber-monday-lifetime-2024 {
      &.ds {
        background-image: url('./assets/images/campaigns/ds-cml2024-bg-banner-mobile.webp');
      }

      &.fa {
        background-image: url('./assets/images/campaigns/fa-cml2024-bg-banner-mobile.webp');
      }

      .header-wrap {
        text-align: center;
        flex-direction: column;

        .highlight.white {
          font-size: 40px;
        }

        .block {
          margin-top: 12px;
          text-align: center;
        }

        svg {
          margin-top: 16px;
          margin-left: 0;
          height: 64px;
        }
      }

      .banner {
        .btn-cyber-monday-lifetime-2024 {
          width: 100%;
          max-width: 327px;
        }
      }
    }

    &.cyber-monday-2024 {
      &.ds {
        background-image: url('./assets/images/campaigns/ds-cm2024-bg-banner-mobile.webp');
      }

      &.fa {
        background-image: url('./assets/images/campaigns/fa-cm2024-bg-banner-mobile.webp');
      }

      .header-wrap {
        text-align: center;
        flex-direction: column-reverse;

        .highlight {
          &.yellow {
            font-size: 77.3px;
            font-weight: 900;
            margin-right: 0;
            line-height: 1.1;

            .smaller {
              display: inline;
              font-size: inherit;
              line-height: inherit;

              .off.block {
                font-size: inherit;
                display: inline;
              }
            }
          }

          &.blue {
            font-size: 41px;
            font-weight: 800;
            line-height: 1;
            margin-top: 8px;
          }
        }

        > div {
          display: flex;
          flex-direction: column-reverse;
        }
      }

      .banner {
        .counter {
          margin-top: 0;
        }

        .btn-cyber-monday-2024 {
          width: 100%;
          max-width: 327px;
        }
      }
    }

    &.black-friday-2024 {
      &.ds {
        background-image: url('./assets/images/campaigns/ds-bf2024-bg-banner-mobile.webp');
      }

      &.fa {
        background-image: url('./assets/images/campaigns/fa-bf2024-bg-banner-mobile.webp');
      }

      .header-wrap {
        text-align: center;
        flex-direction: column-reverse;

        .highlight {
          &.yellow {
            font-size: 77.3px;
            font-weight: 900;
            margin-right: 0;
            line-height: 1.1;

            .smaller {
              display: inline;
              font-size: inherit;
              line-height: inherit;

              .off.block {
                font-size: inherit;
                display: inline;
              }
            }
          }

          &.red {
            font-size: 46px;
            font-weight: 800;
            line-height: 1;
            margin-top: 8px;
          }
        }

        > div {
          display: flex;
          flex-direction: column-reverse;
        }
      }

      .banner {
        .counter {
          margin-top: 0;
        }

        .btn-black-friday-2024 {
          width: 100%;
          max-width: 327px;
        }
      }
    }

    &.learn-data-and-ai,
    &.learn-data-and-ai-new,
    &.learn-finance {
      background-size: cover;

      &.ds {
        background-image: url('assets/images/campaigns/ds-lda-bg-banner-mobile.webp');
      }

      &.fa {
        background-image: url('assets/images/campaigns/fa-lf-bg-banner-mobile.webp');
      }

      .header-wrap {
        text-align: center;
        line-height: 1.1;

        .block {
          display: inline;
        }

        .inline {
          display: block;
        }

        .highlight {
          &.yellow {
            font-size: 36px;
          }

          &.blue {
            font-size: 48px;

            .smaller {
              font-size: 32px;
            }
          }
        }
      }

      .banner .btn-learn-data-and-ai,
      .banner .btn-learn-data-and-ai-new,
      .banner .btn-learn-finance {
        max-width: 327px;
      }
    }

    &.future-proof-2024,
    &.fast-track-2024 {
      background-image: url('assets/images/campaigns/ds-fp2024-bg-banner-mobile.webp');
      background-size: cover;

      .header-wrap {
        .code-block img {
          margin: 0 auto;
        }
      }

      .banner .btn-future-proof-2024,
      .banner .btn-fast-track-2024 {
        max-width: 320px;
      }
    }

    &.finance-courses-offer,
    &.finance-courses-offer.lms,
    &.black-friday {
      padding: 0;

      .fc-heading,
      .bf-heading {
        flex-direction: column;

        .holder-groups {
          width: 100%;

          .groups {
            flex: 50% !important;
            height: 75px;

            .group-1,
            .group-2 {
              font-size: 75px;
            }
          }
        }

        .black-friday {
          font-size: 46px;
          line-height: 110%;
        }

        .limited-time-offer {
          font-size: 24px;
          line-height: 110%;
        }
      }

      .banner .counter {
        margin: var(--spacing-20) 0;
      }

      .btn-primary-purple-dark {
        max-width: 100%;
      }
    }

    &.black-friday {
      background-image: url('./assets/images/sticky-banner-bg-mobile.png');
      border-top: 5px solid rgba(25, 95, 245, 0.5);
    }

    &.free-days {
      a {
        max-height: 100%;

        .header-wrap .fd-heading {
          display: flex;
          flex-direction: column;
          margin-bottom: var(--spacing-8);

          .left-side {
            margin-bottom: 10px;

            span {
              &:not(.banner-highlight) {
                font-size: 57px;
                margin-right: 10px;
              }

              &.banner-highlight {
                width: 40px;
                height: 64px;
                font-size: 35px;
                text-shadow: 0 0 22px var(--accent-light-3);
              }
            }
          }

          .right-side {
            margin: 0;

            .top-part {
              font-size: 33px;
            }

            .bottom-part {
              font-size: 22px;
            }
          }
        }

        .btn-free-days {
          max-width: 327px;
          width: 100% !important;
        }
      }
    }

    &.trigger-offer {
      background: linear-gradient(90deg, #7B61FF -11.15%, #FF5050 62.08%, #FAE391 107.64%);

      .banner.trigger {
        max-width: 327px;

        &.inline {
          p:last-of-type {
            line-height: 35px;
            font-size: 28px;
            padding: 0;
          }
        }

        .counter {
          width: 100%;
          margin-top: var(--spacing-24);
        }

        .btn-trigger-offer {
          margin-top: var(--spacing-24);
          width: 100%;
          height: 52px;
        }
      }
    }

    &.collection-offer {
      padding: var(--spacing-36) 0 var(--spacing-32);

      .banner.collection {
        padding: 0;
        max-width: 327px;

        .icon-wrap {
          margin-right: 0;
          margin-bottom: var(--spacing-14);
        }

        .header-wrap {
          margin-bottom: var(--spacing-24);

          .banner-header {
            .new-line {
              display: block;
            }
          }
        }

        .counter {
          .square {
            width: 76px;
            height: 72px;

            &:after {
              width: 76px;
              height: 72px;
            }
          }
        }

        .btn-collection-offer {
          margin-top: var(--spacing-24);
          width: 100%;
          height: 52px;
        }
      }
    }

    &.most-wanted-2024 {
      height: auto;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;

      &.ds {
        background-image: url('./assets/images/campaigns/ds-mw-bg-banner-mobile.webp');
      }

      &.fa {
        background-image: url('./assets/images/campaigns/fa-mw-bg-banner-mobile.webp');
      }

      .header-wrap {
        text-align: center;

        .line-1 {
          &,
          .highlight,
          .bigger,
          b {
            font-size: 32px;
          }
        }

        .line-2 {
          margin-top: 20px;
          font-size: 21px;

          .highlight {
            font-size: 32px;
            line-height: 56px;
          }

          .bigger,
          b {
            font-size: 18px;
          }
        }
      }

      .btn-primary.btn-transform-your-future-2024 {
        width: 100%;
        max-width: 327px;
        margin-top: 0;
      }
    }

    &.one-of-two-hundred-2024 {
      height: 345px;
      background-position: center;
      background-size: cover;

      &.ds {
        background-image: url('./assets/images/campaigns/ds-oth-bg-banner-mobile.webp');
      }

      &.fa {
        background-image: url('./assets/images/campaigns/fa-oth-bg-banner-mobile.webp');
      }

      &:after {
        bottom: 0.5px;
      }

      .banner {
        padding: var(--spacing-44) 0 52px;
        max-width: 327px;

        .header-wrap .title {
          .line-1 {
            line-height: 36px;
            text-align: center;
            padding: 0 var(--spacing-44);
            margin-bottom: var(--spacing-20);
          }

          .line-2 {
            text-align: center;
            margin-bottom: var(--spacing-14);
          }
        }

        .btn-one-of-two-hundred-2024 {
          width: 100%;
          margin-top: 0;
          top: 0;
          left: -8px;
          margin-bottom: var(--spacing-8);
        }
      }
    }

    &.get-future-ready {
      background-image: url('assets/images/campaign-get-future-ready/dsgfr-bg-banner-mobile.webp');
      background-size: cover;

      .header-wrap {
        text-align: center;

        .main {
          margin-bottom: var(--spacing-4);
        }

        .mobile-block {
          display: block;
        }

        .highlight-special {
          font-size: 33.6px;
          margin-right: -5px;
        }

        .small {
          font-size: 21px;
        }

        .bold {
          font-size: 40px;
          margin-left: 5px;
        }
      }

      .counter {
        margin: 0;
      }

      .banner .btn-get-future-ready {
        max-width: 320px;
      }
    }

    &.campaign-chat-gpt {
      background-image: url('assets/images/campaign-chat-gpt/campaign-chat-gpt-bg-mobile.webp');
      background-size: cover;

      .banner .btn-campaign-chat-gpt {
        max-width: 320px;
      }
    }

    &.transform-your-future-2024 {
      height: auto;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;

      &.ds {
        background-image: url('./assets/images/campaign-transform-your-future-2024/ds-tyf-bg-banner-mobile.webp');
      }

      &.fa {
        background-image: url('./assets/images/campaign-transform-your-future-2024/fa-tyf-bg-banner-mobile.webp');
      }

      .header-wrap {
        text-align: center;

        .line-1 {
          &,
          .highlight,
          .bigger,
          b {
            font-size: 32px;
          }
        }

        .line-2 {
          margin-top: 20px;
          font-size: 21px;

          .highlight {
            font-size: 32px;
            line-height: 56px;
          }

          .bigger,
          b {
            font-size: 18px;
          }
        }
      }

      .btn-primary.btn-transform-your-future-2024 {
        width: 100%;
        max-width: 327px;
        margin-top: 0;
      }
    }

    &.cyber-monday-2023 {
      height: auto;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      border-top: 4px solid var(--c-cm-1);
      border-bottom: 4px solid var(--c-cm-2);

      &.ds {
        background-image: url('./assets/images/campaign-cyber-monday-2023/ds-cm-bg-banner-mobile.webp');
      }

      &.fa {
        background-image: url('./assets/images/campaign-cyber-monday-2023/fa-cm-bg-banner-mobile.webp');

        .header-wrap .main strong,
        &:not(.extend) .btn-primary.btn-cyber-monday-2023 {
          color: var(--main-light);
        }
      }

      &:before,
      &:after {
        content: none !important;
      }

      .header-wrap {
        display: block;
        text-align: center;

        .img {
          height: auto;
          margin-left: auto;
          margin-right: auto;
        }

        .ext-label {
          width: 110px;
          margin-left: auto;
          margin-right: auto;

          + .main .img {
            margin-bottom: 12px;
          }
        }

        .main {
          margin-top: 12px;
          margin-left: 0;

          strong {
            color: var(--main-light);
            margin-bottom: var(--spacing-12);
            font-weight: 900;
          }

          span {
            font-size: 16px;
          }
        }
      }

      .btn-primary.btn-cyber-monday-2023 {
        width: 100%;
        max-width: 327px;
        margin-top: 0;
        color: var(--main-dark);
        background-color: var(--c-cm-2);
      }

      .banner .counter .square {
        height: 54px;
        padding-top: 0;
        padding-bottom: 0;
      }
    }

    &.black-friday-2023 {
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;

      &.ds {
        background-image: url('./assets/images/campaign-black-friday-2023/ds-bf-bg-banner-mobile.webp');
      }

      &.fa {
        background-image: url('./assets/images/campaign-black-friday-2023/fa-bf-bg-banner-mobile.webp');
      }

      .header-wrap {
        display: block;
        text-align: center;

        .img {
          height: auto;
          margin-left: auto;
          margin-right: auto;
        }

        .main strong {
          margin-bottom: var(--spacing-12);
        }
      }

      .btn-primary.btn-black-friday-2023 {
        width: 100%;
        max-width: 327px;
        margin-top: 0;
      }

      .banner .counter .square {
        height: 54px;
        padding-top: 0;
        padding-bottom: 0;
      }
    }

    &.free-weeks-2024 {
      background-size: normal;
      background-position: center;

      &.ds {
        background-image: url('./assets/images/campaigns/ds-fw2024-bg-banner-mobile.webp');
      }

      &.fa {
        background-image: url('./assets/images/campaigns/fa-fw2024-bg-banner-mobile.webp');
      }

      .header-wrap {
        display: block;
        font-size: 24px;
        text-align: center;

        .highlight {
          font-size: 32px;
        }

        svg {
          height: 78px;
          margin: 8px auto;
        }
      }

      .counter .square {
        margin: 0 9px;
      }

      .btn-primary.btn-free-weeks-2024 {
        width: 100%;
        max-width: 327px;
      }
    }

    &.free-access-2024 {
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;

      .banner {
        padding-top: 32px;
        padding-bottom: 32px;
      }

      &.ds {
        background-image: url('./assets/images/campaigns/ds-fa2024-bg-banner-mobile.webp');
      }

      &.fa {
        background-image: url('./assets/images/campaigns/fa-fa2024-bg-banner-mobile.webp');
      }

      .header-wrap {
        text-align: center;
        flex-direction: column;

        .line-1 {
          font-weight: 900;
        }

        .line-2 {
          margin-top: 16px;
        }
      }

      .btn-primary.btn-free-access-2024 {
        width: 100%;
        max-width: 327px;
      }
    }
  }

  .top-banner {
    background: $gradient-bg-mobile;
    width: 100%;

    button {
      margin-top: 16px;
      width: 184px;
      height: 40px;
      left: 0;
      top: 0;
      padding: 8px;
    }

    &.site {
      top: 68px;
    }

    &.free,
    &.free.site {
      .banner {
        .banner-header {
          margin-bottom: 0;
          flex-wrap: wrap;
          justify-content: center;

          .percent {
            font-size: 57px;
          }

          .free {
            span {
              font-size: 36px;
            }
          }

          .unlimited {
            display: block;
            width: 100%;
            margin-top: 10px;
          }
        }

        .banner-info {
          display: none;
        }

        .counter {
          margin: var(--spacing-8) 0 var(--spacing-14);

          .square {
            width: 74px;
          }
        }

        .btn-primary-purple-dark {
          margin-top: 0;
        }
      }
    }

    &.finance-courses-offer,
    &.finance-courses-offer.lms {
      height: 406px;
      background-image: url('./assets/images/finance-courses-offer-banner-mobile.jpg');
      background-size: unset;
      background-repeat: repeat;

      &:after {
        display: none;
      }

      .promo {
        padding: var(--spacing-48) 0;

        .header-wrap {
          .fc-heading {
            .font-wrapper {
              top: 0;
            }

            .finance-courses-offer {
              font-size: 29px;
              text-shadow: 0 1.75792px 4.26924px rgba(37, 244, 238, 0.5), 1.25566px 4.01811px 7.03169px #2D0CEC;
            }

            .limited-time-offer {
              font-size: 24px;
            }
          }
        }

        .counter {
          max-width: 327px;

          .square {
            padding: 0;
            align-items: center;
            justify-content: center;
            height: 80px !important;

            span {
              font-size: 14px;
              width: auto;

              &:first-of-type {
                font-weight: 400;
                font-size: 40px;
                line-height: 110%;
              }
            }
          }
        }

        .btn-finance-courses-offer {
          font-size: 18px;
          margin-top: 0;
          max-width: 327px;
        }
      }

      .close-banner {
        mix-blend-mode: normal;
        top: 13px !important;
        right: 17px !important;

        svg {
          path[stroke] {
            stroke: #1F2737;
            stroke-width: 3px;
          }
        }
      }
    }

    &.top-finance-training {
      padding: var(--spacing-60) var(--spacing-24) var(--spacing-50) var(--spacing-24) !important;
      height: auto;
      background-image: url('./assets/images/banners/tft-site-banner-bg-mobile.webp');
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;

      &:before,
      &:after {
        background-image: none;
        content: '';
        top: unset;
        position: absolute;
        height: 3px;
        width: 100%;
        background-color: var(--accent-light-3-400);
        opacity: 0.47;
      }

      &:before {
        display: block;
        top: 0;
        left: 0;
        z-index: 0;
      }

      &:after {
        bottom: 0;
        left: 0;
      }

      a {
        padding: 0 !important;

        .header-wrap {
          .title {
            margin-bottom: var(--spacing-20);

            .main {
              font-size: 34px;
              line-height: 43px;
              text-align: center;
              text-shadow: 0 3.11775px 7.57167px #036FFD, 0 0 12.471px #036FFD;

              span {
                display: block;
              }
            }

            .subtitle {
              margin: 0;
              flex-direction: column;
              font-weight: 900;
              font-size: 21px;
              line-height: 25px;
              text-shadow: 0 3.11775px 7.57167px #036FFD, 0 0 12.471px #036FFD;

              .highlighted {
                font-size: 32.2px;
                margin: 0;
                line-height: 40px;
              }
            }
          }
        }

        .counter-with-discount {
          width: 327px;
          height: 80px;

          .square {
            padding: var(--spacing-14) 0;

            span {
              color: var(--main-light);
              font-weight: 500;
              font-size: 32px;
              line-height: 110%;

              &.display-text {
                color: var(--main-light);
                font-weight: 400;
                font-size: 12px;
                line-height: 110%;
              }
            }

            &.discount {
              max-width: 129px;
              margin: 0;
              padding: var(--spacing-14) var(--spacing-12);

              span {
                font-size: 32px;
                line-height: 110%;

                &.display-text {
                  font-size: 12px;
                  line-height: 110%;
                }
              }
            }

            &:not(.discount) {
              max-width: 51px;
            }

            &.hours {
              margin: 0 auto 0 9px;
            }

            &.seconds {
              margin: 0 9px 0 auto;
            }
          }
        }

        .btn-top-finance-training {
          margin-top: var(--spacing-20);
          width: 327px;
        }
      }

      .close-banner {
        mix-blend-mode: plus-lighter;
      }

      &.last-promo,
      &.last-promo.lms {
        &:before {
          display: block;
        }

        a .header-wrap .title {
          .main {
            font-size: 44px;
            line-height: 52px;
            text-shadow: 0 2.70152px 6.56083px #036FFD, 0 0 10.8061px #036FFD;
          }

          .subtitle {
            font-weight: 400;
            font-size: 20px;
            line-height: 100%;
            letter-spacing: 0.015em;
            flex-direction: row;
            flex-wrap: wrap;
            align-items: center;

            .highlighted {
              font-size: 23px;
              line-height: 27px;
              margin-left: 7px;
            }
          }
        }
      }
    }

    &.top-finance-training.lms {
      a .header-wrap .title {
        .main {
          font-size: 33px;
        }

        .subtitle .highlighted {
          font-size: 30.7px;
        }
      }
    }
  }
}

@include bp($bp-phone) {
  .top-banner {
    &.free,
    &.free.site {
      .banner {
        .counter {
          .square:not(:last-child) {
            margin-right: 0;

            &:after {
              top: 46%;
              right: -8px;
            }
          }
        }

        .btn-primary-purple-dark {
          width: 100%;
        }
      }
    }

    &.finance-courses-offer {
      height: auto;
      background-image: url('./assets/images/cyber-monday-promo-banner-mobile.png');
      background-repeat: no-repeat;
      background-size: cover;

      &:after {
        display: block;
        border-image: linear-gradient(to bottom, rgba(25, 95, 245, 0.5), rgba(25, 245, 238, 0.5)) 30;
      }

      &.lms {
        height: auto;
        background-image: url('./assets/images/cyber-monday-promo-banner-mobile.png');
        background-repeat: no-repeat;
        background-size: cover;

        &:after {
          display: block;
          border-image: linear-gradient(to bottom, rgba(25, 95, 245, 0.5), rgba(25, 245, 238, 0.5)) 30;
        }

        .promo {
          padding: var(--spacing-48) var(--spacing-24) var(--spacing-48) var(--spacing-24);
        }
      }

      .promo {
        padding: var(--spacing-48) var(--spacing-24) var(--spacing-48) var(--spacing-24);

        .fc-heading .font-wrapper {
          span:after {
            top: -4px;
          }
        }

        .btn-finance-courses-offer {
          font-size: 18px;
          color: #000C1F;
        }
      }
    }

    &.top-finance-training {
      .close-banner {
        mix-blend-mode: normal;
      }

      a {
        .counter-with-discount {
          height: 80px;

          .square {
            width: 51px;
            margin-right: auto;
            padding: var(--spacing-14) 0;

            span {
              font-size: 32px;
            }

            p {
              font-size: 12px;
            }

            &.discount {
              width: 129px;
            }
          }
        }
      }

      @media screen and (max-width: 420px) {
        a {
          .header-wrap .title {
            .main {
              font-size: 8.6vw;
            }

            .subtitle {
              font-size: 6vw;

              .highlighted {
                font-size: 8vw;
              }
            }
          }

          .counter-with-discount {
            max-width: 100%;
          }
        }

        &.lms a {
          .header-wrap .title {
            .main {
              font-size: 8.3vw;
            }

            .subtitle {
              font-size: 6vw;

              .highlighted {
                font-size: 7.6vw;
              }
            }
          }

          .counter-with-discount {
            max-width: 100%;
          }
        }

        &.last-promo,
        &.last-promo.lms {
          a .header-wrap .title {
            .main {
              font-size: 11vw;
            }

            .subtitle {
              font-size: 4.8vw;

              .highlighted {
                font-size: 5.7vw;
              }
            }
          }
        }

        .btn-top-finance-training {
          max-width: 100%;
          width: 100%;
        }
      }
    }

    &.got-what-it-takes {
      background-image: url('./assets/images/banners/gwt-promo-banner-mobile-bg.jpg');
      padding: var(--spacing-40) var(--spacing-24) var(--spacing-24);

      .promo {
        padding: 0;
      }

      .close-banner {
        right: 17px;
        top: 7px;
      }
    }
  }

  .banner-holder {
    &.free-days.site,
    &.free-days.lms {
      padding: var(--spacing-40) var(--spacing-24) var(--spacing-24) var(--spacing-24);

      a {
        padding: 0;

        .header-wrap {
          .fd-heading {
            .left-side {
              span:not(.banner-highlight) {
                width: 146px;
                font-size: 56px;
              }
            }
          }
        }

        .counter {
          margin: 0;
        }
      }

      .close-banner {
        top: 6px;
        right: 16px;
      }
    }

    &.trigger-offer {
      background: none;
      background-image: url(./assets/images/banners/trigger-offer-bg-mobile.jpg);
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;

      .banner.trigger {
        padding: var(--spacing-36) var(--spacing-24) var(--spacing-30);
        max-width: 100%;

        .banner-info {
          padding: 0 10px;
        }
      }

      .close-banner {
        top: 12px;
        right: 16px;
      }
    }

    &.collection-offer {
      background: linear-gradient(180deg, #FAE391 -31.6%, #7B61FF 131.06%);
      padding-left: var(--spacing-24);
      padding-right: var(--spacing-24);

      .banner.collection {
        max-width: 100%;

        .counter {
          width: 100%;

          .square {
            width: auto;

            &:after {
              width: 100%;
            }
          }
        }
      }
    }

    &.one-of-two-hundred-2024 {
      background-image: url('./assets/images/banners/oth-promo-banner-mobile-bg.jpg');
      background-position: 0% 0%;
    }

    &.future-proof-2024,
    &.fast-track-2024 {
      .header-wrap {
        text-align: center;

        .main {
          font-size: 32px;
        }

        .highlight {
          font-size: 31px;
          margin-top: 12px;

          &.blue {
            display: block;
          }
        }
      }
    }

    &.campaign-chat-gpt {
      .header-wrap {
        flex-direction: column;

        .right {
          margin-left: 0;
          margin-top: var(--spacing-16);

          .highlight {
            display: inline;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 360px) {
  .top-banner {
    &.free,
    &.free.site {
      .banner {
        .banner-header {
          .percent {
            margin-bottom: 10px;
          }
        }
      }
    }

    &.top-finance-training {
      a {
        .counter-with-discount {
          height: fit-content;
          flex-wrap: wrap;
          justify-content: space-around;

          .square {
            margin: 0;

            &.discount {
              flex-basis: 100%;
              max-width: 100%;
              width: 100%;
              border-right: none !important;
              border-bottom: 1px solid var(--accent-light-3-400);
              margin-right: 0 !important;

              span {
                width: 100% !important;
              }
            }
          }
        }
      }

      &.last-promo,
      &.last-promo.lms {
        a .header-wrap .title {
          .subtitle {
            flex-direction: column;

            .highlighted {
              margin: 0 auto;
              font-size: 7vw;
            }
          }
        }
      }
    }

    &.finance-courses-offer,
    &.free-days,
    &.got-what-it-takes {
      a {
        .header-wrap,
        .counter {
          transform: scale(0.85);
        }

        .btn-got-what-it-takes {
          max-width: 100%;
        }
      }
    }

    &.trigger-offer {
      .banner.trigger {
        .counter {
          .square {
            padding: var(--spacing-8) 0;
          }
        }
      }
    }

    &.collection-offer {
      .banner.collection {
        .counter {
          .square {
            padding: var(--spacing-8) 0;
          }
        }
      }
    }

    &.one-of-two-hundred-2024 {
      .banner .btn-one-of-two-hundred-2024 {
        width: 90%;
        left: -4px;
      }
    }
  }
}

@media screen and (min-width: 1440px) {
  .banner-holder.transform-your-future-2024.fa .banner {
    padding: 0 50px;
  }
}
</style>
